// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
*
* Base stylesheet
* Author: PJ
* Design and Developed by: PJ
* NOTE: This file contains the styling for responsive Template.
*
*/

:root {
  --pf-primary: #F37920;
  --pf-secondary: #ccced2;
  --pf-success: #b7e1ba;
  --pf-info: #ffe6de;
  --pf-warning: #ffebdf;
  --pf-danger: #ffdaeb;
  --pf-light: #FAFAFA;
  --pf-dark: rgba(199, 203, 211, 0.1);
  --pf-orange: #ffdcd8;
  --pf-purple: #cbc0ff;
  --pf-pink: #fff1f1;
  --pf-primary-t: rgba(71, 136, 255, 0.1);
  --pf-secondary-t: rgba(108, 117, 125, 0.1);
  --pf-success-t: rgba(55, 230, 178, 0.1);
  --pf-info-t: rgba(135, 108, 254, 0.1);
  --pf-warning-t: rgba(254, 114, 28, 0.1);
  --pf-danger-t: rgba(255, 75, 75, 0.1);
  --pf-light-t: rgba(199, 203, 211, 0.1);
  --pf-dark-t: rgba(1, 4, 27, 0.1);
  --pf-orange-t: rgba(253, 126, 20, 0.1);
  --pf-purple-t: rgba(71, 49, 182, 0.1); 
  --c-grey-100: #f4f6f8;
  --c-grey-200: #e3e3e3;
  --c-grey-300: #b2b2b2;
  --c-grey-400: #7b7b7b;
  --c-grey-500: #3d3d3d;
  --c-blue-500: #688afd;
  }


.login-content .pf-sign-user_card {
    padding: 30px;
    border:none !important;
    text-align: center;
    border-radius: 8px;
}
.pf-shadow{
-ms-box-shadow: 0 16px 40px 0 rgba(0,0,0,.0392157);
    -o-box-shadow: 0 16px 40px 0 rgba(0,0,0,.0392157);
    box-shadow: 0 16px 40px 0 rgba(0,0,0,.0392157);	
}
.btn-primary {
    color: #fff;
    background-color: var(--pf-primary) !important;
    border-color: var(--pf-primary) !important;
    box-shadow: unset;
}
.btn:hover {color:#fff !important}
/* ================================== Elements ================================== */
a {
color: #F37920;
text-decoration: none;
}
a:hover {color:rgba(15,67,144,0.7) !important;}
.bg-primary {
  color: #fff !important;
  background-color:var(--pf-primary) !important; }
a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  color: #fff !important;
  background-color: rgba(15,67,144,0.7) !important; }

.badge-primary {
  color: #fff !important;
  background-color: #145886 !important; }

a.badge-primary:hover, a.badge-primary:focus,
button.badge-primary:hover,
button.badge-primary:focus {
  color: #fff !important;
  background-color:  rgba(15,67,144,0.7) !important; } 
  
 /* ================================== Menu ================================== */
.pa-s-navmenu .img-nav i{width:30px;}
.pf-sign-or {border-bottom:1px solid #ddd; position:relative; margin:30px 0;}
.pf-sign-or span {position:absolute; left:50%; top:-20px; display:inline-block; padding:5px; background:#fff; text-align:center; border-radius:50%;}
 /* ================================== Login ================================== */
.login-with-google-btn {
  transition: background-color 0.3s, box-shadow 0.3s;
  padding: 12px 16px 12px 42px;
  border: none;
  border-radius: 35px;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: white;
  background-repeat: no-repeat;
  background-position: 12px 11px;
}
.login-with-google-btn:hover {
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25);
}
.login-with-google-btn:active {
  background-color: #eeeeee;
}
.login-with-google-btn:focus {
  outline: none;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc;
}
.login-with-google-btn:disabled {
  filter: grayscale(100%);
  background-color: #ebebeb;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
 /* ================================== Dashboard ================================== */

.pa-welcome-notifi { margin-bottom:20px; font-size:20px !important;}
.pf-h-icon-box{ transition: 0.3s; background:#ddd; border-radius:8px;}
.pf-h-icon-box:hover {background:#ececf7;

}

.pf-download-noti { padding:0 20px !important}
#fx-pricing-widget-copyright {display:none !important}
.pf-h-icon-box img { height:40px !important}
.pa-forex-list { margin-top:5px;}
.pa-forex-list a {
    border-bottom:1px solid #ffffff4f;
    padding: 10px 0px 0;
}

.pa-forex-list img {width: 25px; height: 25px; margin-right: 15px;}
.pa-forex-list h2,
.pa-forex-list h3
{font-size:14px;text-align: left;margin-bottom: 0;
    line-height: 1;}
.pa-forex-list p {font-size: 12px !important; color:#000 !important;text-align: left; margin-bottom:2px;}
.pa-cforex-flag { width:28px; height:28px; border-radius:50%;}

.pa-upload-wrap h2s { font-size:20px;}
.datepicker {
z-index:99990 !important;
}
.filepond--panel-root {
    border-radius: .5em;
    background-color: #fff;
}
.filepond--panel.filepond--panel-root {
    border: 2px dashed #eee !important;
    background: #fff !important; overflow:hidden;
}
.filepond--panel-bottom, .filepond--panel-top {
 
}
.filepond--root .filepond--drop-label {
    min-height: 10em;
}
.input-group-addon{
    position: absolute;
top: 50%; left: 25px; font-size: 23px;
}
.pa-upload-wrap .datepicker .form-control { padding-left: 35px; padding-top: 9px;}

/* ================================== CHAT ================================== */
#pa-chatframe {
  width: 100%;
  min-width: 360px;
  max-width: 100%;
  height: 92vh;
  min-height: 300px;
  max-height: 720px;
  background: #E6EAEA;
  border-radius: 10px;
  overflow:hidden;
}
@media screen and (max-width: 360px) {
  #pa-chatframe {
    width: 100%;
    height: 100vh;
  }
  .pa-welcome-notifi {
    margin-top: 20px;
}
.iq-top-navbar .navbar-toggler {
    color: #e1e2ff;
    background: #F37920;
}
.wrapper-menu {
    color: #F37920;
}
}
#pa-chatframe #sidepanel {
  float: left;
  min-width: 280px;
  max-width: 340px;
  width: 40%;
  height: 100%;
  background: #f3f5f7;
  box-shadow: 0px 20px 38px 0px rgb(188 196 227 / 63%);
  color: #f5f5f5;
  overflow: hidden;
  position: relative;
  border-radius: 10px 0 0 10px;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel {
    width: 58px;
    min-width: 58px;
  }
  .pa-welcome-notifi {
    margin-top: 30px;
}
}
#pa-chatframe #sidepanel #profile {
  width: 80%;
  margin: 25px auto 0px auto;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile {
    width: 100%;
    margin: 0 auto;
    padding: 5px 0 0 0;
    background: #32465a;
  }
}
#pa-chatframe #sidepanel #profile.expanded .wrap {
  height: 210px;
  line-height: initial;
}
#pa-chatframe #sidepanel #profile.expanded .wrap p {
  margin-top: 20px;
}
#pa-chatframe #sidepanel #profile.expanded .wrap i.expand-button {
  transform: scaleY(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
#pa-chatframe #sidepanel #profile .wrap {
  height: 60px;
  line-height: 60px;
  overflow: hidden;
  transition: 0.3s height ease;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap {
    height: 55px;
  }
}
#pa-chatframe #sidepanel #profile .wrap img {
  width: 50px;
  border-radius: 50%;
  padding: 3px;
  border: 2px solid #e74c3c;
  height: auto;
  float: left;
  cursor: pointer;
  transition: 0.3s border ease;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap img {
    width: 40px;
    margin-left: 4px;
  }
}
#pa-chatframe #sidepanel #profile .wrap img.online {
  border: 2px solid #2ecc71;
}
#pa-chatframe #sidepanel #profile .wrap img.away {
  border: 2px solid #f1c40f;
}
#pa-chatframe #sidepanel #profile .wrap img.busy {
  border: 2px solid #e74c3c;
}
#pa-chatframe #sidepanel #profile .wrap img.offline {
  border: 2px solid #95a5a6;
}
#pa-chatframe #sidepanel #profile .wrap p {
  float: left;
  margin-left: 15px;color:#000;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap p {
    display: none;
  }
}
#pa-chatframe #sidepanel #profile .wrap i.expand-button {
  float: right;
  margin-top: 23px;
  font-size: 0.8em;
  cursor: pointer;
  color: #435f7a;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap i.expand-button {
    display: none;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  width: 150px;
  margin: 70px 0 0 0;
  border-radius: 6px;
  z-index: 99;
  line-height: initial;
  background: #435f7a;
  transition: 0.3s all ease;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options {
    width: 58px;
    margin-top: 57px;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options.active {
  opacity: 1;
  visibility: visible;
  margin: 75px 0 0 0;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options.active {
    margin-top: 62px;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid #435f7a;
  margin: -8px 0 0 24px;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options:before {
    margin-left: 23px;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul {
  overflow: hidden;
  border-radius: 6px;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li {
  padding: 15px 0 30px 18px;
  display: block;
  cursor: pointer;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options ul li {
    padding: 15px 0 35px 22px;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li:hover {
  background: #496886;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 5px 0 0 0;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle {
    width: 14px;
    height: 14px;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle:before {
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  margin: -3px 0 0 -3px;
  background: transparent;
  border-radius: 50%;
  z-index: 0;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle:before {
    height: 18px;
    width: 18px;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li p {
  padding-left: 12px;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #profile .wrap #status-options ul li p {
    display: none;
  }
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-online span.status-circle {
  background: #2ecc71;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-online.active span.status-circle:before {
  border: 1px solid #2ecc71;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-away span.status-circle {
  background: #f1c40f;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-away.active span.status-circle:before {
  border: 1px solid #f1c40f;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-busy span.status-circle {
  background: #e74c3c;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-busy.active span.status-circle:before {
  border: 1px solid #e74c3c;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-offline span.status-circle {
  background: #95a5a6;
}
#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-offline.active span.status-circle:before {
  border: 1px solid #95a5a6;
}
#pa-chatframe #sidepanel #profile .wrap #expanded {
  padding: 100px 0 0 0;
  display: block;
  line-height: initial !important;
}
#pa-chatframe #sidepanel #profile .wrap #expanded label {
  float: left;
  clear: both;
  margin: 0 8px 5px 0;
  padding: 5px 0;
}
#pa-chatframe #sidepanel #profile .wrap #expanded input {
  border: none;
  margin-bottom: 6px;
  background: #32465a;
  border-radius: 3px;
  color: #f5f5f5;
  padding: 7px;
  width: calc(100% - 43px);
}
#pa-chatframe #sidepanel #profile .wrap #expanded input:focus {
  outline: none;
  background: #435f7a;
}
#pa-chatframe #sidepanel #g-chat {
  border-top: 1px solid #32465a;
  border-bottom: 1px solid #32465a;
  font-weight: 300;
  margin:0 20px 20px 24px;
  padding-bottom:60px;
  position:relative;
}
#pa-chatframe #sidepanel #g-chat h2{font-size:14px;font-weight:bold; color:#000; margin:15px 0;}
#pa-chatframe #sidepanel #g-chat label {
    color: #7c81a3;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #g-chat {
    display: none;
  }
}
#pa-chatframe #sidepanel #g-chat label {
  position: absolute;
  margin: 10px 0 0 20px;
}
#pa-chatframe #sidepanel #g-chat textarea {
  padding:15px;
  font-size: 13px;
  width: 100%;
  border: none;
  background: #dee2e5;
  color: #000;
  margin: 0 auto;
    display: block;
	border-radius:8px;
}
#pa-chatframe #sidepanel #g-chat button
 {
  position:absolute;
  margin-top:5px;
  right:0;
  border: none;
  width: 40px;
  height:40px;
  text-align:center;
  cursor: pointer;
  background: #04AA6D;
  color: #fff;
 border-radius:50%;
}
.choose-clent {font-size:14px; color:#000; margin-left:24px;}
#pa-chatframe #sidepanel #g-chat input:focus {
  outline: none;
  background: #435f7a;
}
#pa-chatframe #sidepanel #g-chat input::-webkit-input-placeholder {
  color: rgba(255,255,255,0.5);
}
#pa-chatframe #sidepanel #g-chat input::-moz-placeholder {
  color:rgba(255,255,255,0.5);
}
#pa-chatframe #sidepanel #g-chat input:-ms-input-placeholder {
  color:rgba(255,255,255,0.5);
}
#pa-chatframe #sidepanel #g-chat input:-moz-placeholder {
  color:rgba(255,255,255,0.5);
}
#pa-chatframe #sidepanel #contacts {
  height: calc(100% - 130px);
  overflow-y: scroll;
  overflow-x: hidden;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #contacts {
    height: calc(100% - 149px);
    overflow-y: scroll;
    overflow-x: hidden;
  }
  #pa-chatframe #sidepanel #contacts::-webkit-scrollbar {
    display: none;
  }
}
#pa-chatframe #sidepanel #contacts.expanded {
  height: calc(100% - 334px);
}
#pa-chatframe #sidepanel #contacts::-webkit-scrollbar {
  width: 8px;
  background: #2c3e50;
}
#pa-chatframe #sidepanel #contacts::-webkit-scrollbar-thumb {
  background-color: #243140;
}
#pa-chatframe #sidepanel #contacts ul li.contact {
  position: relative;
  padding: 10px 15px 15px 15px;
  margin-bottom:15px;
  background:#eee;
  border-radius:15px;
  font-size: 0.9em;
  cursor: pointer;
  transition: 1s all ease;
}
#pa-chatframe #sidepanel #contacts ul li.contact:hover .name,
#pa-chatframe #sidepanel #contacts ul li.contact:hover .preview
{
color:#fff !important;	
}
#pa-chatframe #sidepanel #contacts ul li.contact .preview
{
font-size: 12px !important;
}
#pa-chatframe #contacts ul {margin:0 24px 50px; padding:0;}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta p{margin-bottom:0}
@media screen and (max-width: 735px) {

  #pa-chatframe #sidepanel #contacts ul li.contact {
    padding: 6px 0 46px 8px;	
  }
}
#pa-chatframe #sidepanel #contacts ul li.contact:hover {
  background: #32465a;
}
#pa-chatframe #sidepanel #contacts ul li.contact.active {
  background: #32465a;
}
#pa-chatframe #sidepanel #contacts ul li.contact.active span.contact-status {
  border: 0px solid #32465a !important;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #contacts ul li.contact .wrap {
    width: 100%;
  }
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap span {
  position: absolute;
  left: 0;
  margin: -2px 0 0 -2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #95a5a6;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap span.online {
  background: #2ecc71;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap span.away {
  background: #f1c40f;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap span.busy {
  background: #e74c3c;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap img {
  width: 40px;
  border-radius: 50%;
  float: left;
  margin-right: 10px;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #contacts ul li.contact .wrap img {
    margin-right: 0px;
  }
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta {
  padding: 0px 0 0 0;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta {
    display: none;
  }
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta .name {
  font-weight: 600;font-size: 13px; color:#000;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta .preview {
	color:#000;
  margin: 0px 0 0 0;
  padding: 0 0 0px;
  font-weight: 400;
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta .preview span {
  position: initial;
  border-radius: initial;
  background: none;
  border: none;
  padding: 0 2px 0 0;
  margin: 0 0 0 1px;
  opacity: 0.5;
}
#pa-chatframe #sidepanel #contacts ul li.contact.active .meta .name,
#pa-chatframe #sidepanel #contacts ul li.contact.active .meta .preview
{color:#fff;}

#pa-chatframe #sidepanel #bottom-bar {
  position: absolute;
  width: 100%;
  bottom: 0;
}
#pa-chatframe #sidepanel #bottom-bar button {
  float: left;
  border: none;
  width: 50%;
  padding: 10px 0;
  background: #32465a;
  color: #f5f5f5;
  cursor: pointer;
  font-size: 0.85em;
  font-family: "proxima-nova", "Source Sans Pro", sans-serif;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #bottom-bar button {
    float: none;
    width: 100%;
    padding: 15px 0;
  }
}
#pa-chatframe #sidepanel #bottom-bar button:focus {
  outline: none;
}
#pa-chatframe #sidepanel #bottom-bar button:nth-child(1) {
  border-right: 1px solid #2c3e50;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #bottom-bar button:nth-child(1) {
    border-right: none;
    border-bottom: 1px solid #2c3e50;
  }
}
#pa-chatframe #sidepanel #bottom-bar button:hover {
  background: #435f7a;
}
#pa-chatframe #sidepanel #bottom-bar button i {
  margin-right: 3px;
  font-size: 1em;
}
@media screen and (max-width: 735px) {
  #pa-chatframe #sidepanel #bottom-bar button i {
    font-size: 1.3em;
  }
  #pa-chatframe #sidepanel #bottom-bar button span {
    display: none;
  }
}
#pa-chatframe .content {
  float: right;
  width: 60%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
@media screen and (max-width: 735px) {
  #pa-chatframe .content {
    width: calc(100% - 58px);
    min-width: 300px !important;
  }
}
@media screen and (min-width: 900px) {
  #pa-chatframe .content {
    width: calc(100% - 340px);
  }
  #pa-chatframe .content-100 {
    width: 100%;
  }
}
#pa-chatframe .content .contact-profile {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #f5f5f5;
}
#pa-chatframe .content .contact-profile img {
  width: 40px;
  border-radius: 50%;
  float: left;
  margin: 9px 12px 0 9px;
}
#pa-chatframe .content .contact-profile p {
  float: left;
}
#pa-chatframe .content .contact-profile .social-media {
  float: right;
}
#pa-chatframe .content .contact-profile .social-media i {
  margin-left: 14px;
  cursor: pointer;
}
#pa-chatframe .content .contact-profile .social-media i:nth-last-child(1) {
  margin-right: 20px;
}
#pa-chatframe .content .contact-profile .social-media i:hover {
  color: #435f7a;
}
#pa-chatframe .content .messages {
  height: auto;
  min-height: calc(100% - 93px);
  max-height: calc(100% - 93px);
  overflow-y: scroll;
  overflow-x: hidden;
}
@media screen and (max-width: 735px) {
  #pa-chatframe .content .messages {
    max-height: calc(100% - 105px);
  }
}
#pa-chatframe .content .messages::-webkit-scrollbar {
  width: 8px;
  background: rgba(0, 0, 0, 0);
}
#pa-chatframe .content .messages::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
}
#pa-chatframe .content .messages ul li {
  display: inline-block;
  clear: both;
  float: left;
  margin: 15px 15px 5px 15px;
  width: calc(100% - 25px);
  font-size: 0.9em;
}
#pa-chatframe .content .messages ul li:nth-last-child(1) {
  margin-bottom: 20px;
}
#pa-chatframe .content .messages ul li.sent img {
  margin: 6px 8px 0 0;
}
#pa-chatframe .content .messages ul li.sent p {
  background: #435f7a;
  color: #f5f5f5;
}
#pa-chatframe .content .messages ul li.replies img {
  float: right;
  margin: 6px 0 0 8px;
}
#pa-chatframe .content .messages ul li.replies p {
  background: #f5f5f5;
  float: right;
}
#pa-chatframe .content .messages ul li img {
  width: 22px;
  border-radius: 50%;
  float: left;
}
#pa-chatframe .content .messages ul li p {
  display: inline-block;
  padding: 10px 15px;
  border-radius: 8px;
  max-width: 205px;
  line-height: 130%;
  font-size: 13px!important;
}
@media screen and (min-width: 735px) {
  #pa-chatframe .content .messages ul li p {
    max-width: 300px;
  }
}
#pa-chatframe .content .message-input {
  position: absolute;
  bottom: 5px;
  width: 100%;
  z-index: 99;
}
#pa-chatframe .content .message-input .wrap {
  position: relative;
}
#pa-chatframe .content .message-input .wrap input {
  font-family: "proxima-nova", "Source Sans Pro", sans-serif;
  float: left;
  border: none;
  width: calc(100% - 90px);
  padding: 11px 32px 10px 20px;
  font-size: 0.8em;
  color: #32465a;
border-radius: 30px;
    margin-left: 20px;
}
@media screen and (max-width: 735px) {
  #pa-chatframe .content .message-input .wrap input {
    padding: 15px 32px 16px 8px;
  }
 .webui-popover {
    min-width: 100%;
} 
}
#pa-chatframe .content .message-input .wrap input:focus {
  outline: none;
}
#pa-chatframe .content .message-input .wrap .attachment {
  position: absolute;
  right: 80px;
  z-index: 4;
  margin-top: 10px;
  font-size: 1.1em;
  color: #435f7a;
  opacity: 0.5;
  cursor: pointer;
}
@media screen and (max-width: 735px) {
  #pa-chatframe .content .message-input .wrap .attachment {
    margin-top: 17px;
    right: 65px;
  }
}
#pa-chatframe .content .message-input .wrap .attachment:hover {
  opacity: 1;
}
#pa-chatframe .content .message-input .wrap button {
  float: right;
  border: none;
    width: 40px;
    padding: 12px 0;
    cursor: pointer;
    background: #32465a;
    color: #f5f5f5;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
    margin-top: -2px;
}
@media screen and (max-width: 735px) {
  #pa-chatframe .content .message-input .wrap button {
    padding: 16px 0;
  }
}
#pa-chatframe .content .message-input .wrap button:hover {
  background: #435f7a;
}
#pa-chatframe .content .message-input .wrap button:focus {
  outline: none;
}



/* ================================== Pagination ================================== */
.pa-pagination ul{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  margin-top:30px;
  padding: 8px;
  border-radius: 50px;
  box-shadow: 0px 10px 15px rgba(0,0,0,0.1);
}
.pa-pagination ul li{
  color: #F37920;
  list-style: none;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.3s ease;
}
.pa-pagination ul li.numb{
  list-style: none;
  height: 45px;
  width: 45px;
  margin: 0 3px;
  line-height: 45px;
  border-radius: 50%;
}
.pa-pagination ul li.numb.first{
  margin: 0px 3px 0 -5px;
}
.pa-pagination ul li.numb.last{
  margin: 0px -5px 0 3px;
}
.pa-pagination ul li.dots{
  font-size: 22px;
  cursor: default;
}
.pa-pagination ul li.btn{
  padding: 0 20px;
  border-radius: 50px;
}
.pa-pagination li.active,
.pa-pagination ul li.numb:hover,
.pa-pagination ul li:first-child:hover,
.pa-pagination ul li:last-child:hover{
  color: #fff;
  background: #F37920;
}
/* ================================== Activities ================================== */

.pa-filter-wrap {
  display: flex;
  align-items: center;
     background-color: #f9f9f9;
   border: 1px solid #ddd;
   border-radius:10px; padding:20px;
  }
.pa-filter-name { margin-right:20px;}
.choices__inner {
   background-color:transparent !important;
   border: 1px solid transparent!important;
}
.choices__list--dropdown {min-width: 200px;}
.pa-act-profile { position:relative;  
display: flex;
  justify-content: center;
  align-items: center;}
.pa-act-profile .pa-act-img{display:inline-block; width:50px; height:50px; border-radius:50px;}
.pa-act-profile .pa-act-meta {display:inline-block; margin-left:20px;}
.pa-act-profile .pa-act-meta h3 {font-size:14px; font-weight:bold;}
.pa-act-action {font-size:12px; font-weight:normal; margin-top:15px !important; color:#b7b3b3; font-style:italic;}
.pa-act-profile .pa-act-meta p {font-size:12px; font-weight:normal;}
.pa-act-profile .pa-act-img img {width:100%;}
.pa-upload-icon img { width:40px;}
.pa-upload-wrap h4,
.jl-heading {font-size:16px; font-weight:bold;}
/* ================================== Timeline ================================== */

.pa-timeline-wrap h4 { font-size:16px; font-weight:bold; margin:40px 0 20px 0;}
.pa-timeline {
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
}
.pa-timeline .image {
  padding: 1em 2em;    margin-top: 20px;
}
.pa-timeline .image > div {
  position: relative;
  text-align: center;
  font-size: 0.8em;
  z-index:10;
}
.pa-timeline .image > div::after {
  content: "";
  width: 100%;
  height: 0;
  border-bottom: 1px solid #eee;
  position: absolute;
  top: 1.75em;
  left: 2.5em;
  z-index:1;
}
.pa-timeline .image .img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background:#eee;
  text-align:center;
      margin: 0 auto;
}
.pa-timeline .image .img img {
    width: 65%;
    margin: 0 auto;
    display: block;
    padding: 6px 0 0;
}
.pa-timeline .image span {
  display: block;
  clear: both;
padding: 2px 7px;
    margin: 0.5em 0;
    background: #fff;
    border-radius: 35px;
}
.pa-timeline .details {
  position: relative;
  flex-grow: 1;
}
.pa-timeline .details > div {
  border: 1px solid #eee;
  background: #eee;
  border-radius: 0.5em;
  padding: 1.5em;
  margin: 1em 0;
}
.pa-timeline .details > div h1 {
  color: #5ed3bf;
  font-size: 1.4em;
  margin: 0;
  padding: 0 0 0.5em 0;
  letter-spacing: 0.1em;
}
.pa-timeline .details > div p {
  margin: 0;
  padding: 0;
  line-height: 150%;
  font-size: 14px;
}
.pa-timeline .details::before {
  content: "";
  width: 0;
  height: 100%;
  border-left: 1px solid #eee;
  position: absolute;
  top: 0;
  left:-4.3em;
  z-index: 1;
}
/* ============ Toggle ============ */
.btn-toggle {
  margin: 0 4rem;
  padding: 0;
  position: relative;
  border: none;
  height: 1.5rem;
  width: 3rem;
  border-radius: 1.5rem;
  color: #6b7381;
  background: #bdc1c8;
}
.btn-toggle:focus,
.btn-toggle.focus,
.btn-toggle:focus.active,
.btn-toggle.focus.active {
  outline: none;
}
.btn-toggle:before,
.btn-toggle:after {
  line-height: 1.5rem;
  width: 4rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 0;
  transition: opacity 0.25s;
}
.btn-toggle:before {
  content: 'Off';
  left: -4rem;
}
.btn-toggle:after {
  content: 'On';
  right: -4rem;
  opacity: 0.5;
}
.btn-toggle > .handle {
  position: absolute;
  top: 0.1875rem;
  left: 0.1875rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 1.125rem;
  background: #fff;
  transition: left 0.25s;
}
.btn-toggle.active {
  transition: background-color 0.25s;
}
.btn-toggle.active > .handle {
  left: 1.6875rem;
  transition: left 0.25s;
}
.btn-toggle.active:before {
  opacity: 0.5;
}
.btn-toggle.active:after {
  opacity: 1;
}
.btn-toggle.btn-sm:before,
.btn-toggle.btn-sm:after {
  line-height: -0.5rem;
  color: #fff;
  letter-spacing: 0.75px;
  left: 0.4125rem;
  width: 2.325rem;
}
.btn-toggle.btn-sm:before {
  text-align: right;
}
.btn-toggle.btn-sm:after {
  text-align: left;
  opacity: 0;
}
.btn-toggle.btn-sm.active:before {
  opacity: 0;
}
.btn-toggle.btn-sm.active:after {
  opacity: 1;
}
.btn-toggle.btn-xs:before,
.btn-toggle.btn-xs:after {
  display: none;
}
.btn-toggle:before,
.btn-toggle:after {
  color: #6b7381;
}
.btn-toggle.active {
  background-color: #29b5a8;
}
.btn-toggle.btn-lg {
  margin: 0 5rem;
  padding: 0;
  position: relative;
  border: none;
  height: 2.5rem;
  width: 5rem;
  border-radius: 2.5rem;
}
.btn-toggle.btn-lg:focus,
.btn-toggle.btn-lg.focus,
.btn-toggle.btn-lg:focus.active,
.btn-toggle.btn-lg.focus.active {
  outline: none;
}
.btn-toggle.btn-lg:before,
.btn-toggle.btn-lg:after {
  line-height: 2.5rem;
  width: 5rem;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 0;
  transition: opacity 0.25s;
}
.btn-toggle.btn-lg:before {
  content: 'Off';
  left: -5rem;
}
.btn-toggle.btn-lg:after {
  content: 'On';
  right: -5rem;
  opacity: 0.5;
}
.btn-toggle.btn-lg > .handle {
  position: absolute;
  top: 0.3125rem;
  left: 0.3125rem;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 1.875rem;
  background: #fff;
  transition: left 0.25s;
}
.btn-toggle.btn-lg.active {
  transition: background-color 0.25s;
}
.btn-toggle.btn-lg.active > .handle {
  left: 2.8125rem;
  transition: left 0.25s;
}
.btn-toggle.btn-lg.active:before {
  opacity: 0.5;
}
.btn-toggle.btn-lg.active:after {
  opacity: 1;
}
.btn-toggle.btn-lg.btn-sm:before,
.btn-toggle.btn-lg.btn-sm:after {
  line-height: 0.5rem;
  color: #fff;
  letter-spacing: 0.75px;
  left: 0.6875rem;
  width: 3.875rem;
}
.btn-toggle.btn-lg.btn-sm:before {
  text-align: right;
}
.btn-toggle.btn-lg.btn-sm:after {
  text-align: left;
  opacity: 0;
}
.btn-toggle.btn-lg.btn-sm.active:before {
  opacity: 0;
}
.btn-toggle.btn-lg.btn-sm.active:after {
  opacity: 1;
}
.btn-toggle.btn-lg.btn-xs:before,
.btn-toggle.btn-lg.btn-xs:after {
  display: none;
}
.btn-toggle.btn-sm {
  margin: 0 0.5rem;
  padding: 0;
  position: relative;
  border: none;
  height: 1.5rem;
  width: 3rem;
  border-radius: 1.5rem;
}
.btn-toggle.btn-sm:focus,
.btn-toggle.btn-sm.focus,
.btn-toggle.btn-sm:focus.active,
.btn-toggle.btn-sm.focus.active {
  outline: none;
}
.btn-toggle.btn-sm:before,
.btn-toggle.btn-sm:after {
  line-height: 1.5rem;
  width: 0.5rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.55rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 0;
  transition: opacity 0.25s;
}
.btn-toggle.btn-sm:before {
  content: 'Off';
  left: -0.5rem;
}
.btn-toggle.btn-sm:after {
  content: 'On';
  right: -0.5rem;
  opacity: 0.5;
}
.btn-toggle.btn-sm > .handle {
  position: absolute;
  top: 0.1875rem;
  left: 0.1875rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 1.125rem;
  background: #fff;
  transition: left 0.25s;
}
.btn-toggle.btn-sm.active {
  transition: background-color 0.25s;
}
.btn-toggle.btn-sm.active > .handle {
  left: 1.6875rem;
  transition: left 0.25s;
}
.btn-toggle.btn-sm.active:before {
  opacity: 0.5;
}
.btn-toggle.btn-sm.active:after {
  opacity: 1;
}
.btn-toggle.btn-sm.btn-sm:before,
.btn-toggle.btn-sm.btn-sm:after {
  line-height: -0.5rem;
  color: #fff;
  letter-spacing: 0.75px;
  left: 0.4125rem;
  width: 2.325rem;
}
.btn-toggle.btn-sm.btn-sm:before {
  text-align: right;
}
.btn-toggle.btn-sm.btn-sm:after {
  text-align: left;
  opacity: 0;
}
.btn-toggle.btn-sm.btn-sm.active:before {
  opacity: 0;
}
.btn-toggle.btn-sm.btn-sm.active:after {
  opacity: 1;
}
.btn-toggle.btn-sm.btn-xs:before,
.btn-toggle.btn-sm.btn-xs:after {
  display: none;
}
.btn-toggle.btn-xs {
  margin: 0 0;
  padding: 0;
  position: relative;
  border: none;
  height: 1rem;
  width: 2rem;
  border-radius: 1rem;
}
.btn-toggle.btn-xs:focus,
.btn-toggle.btn-xs.focus,
.btn-toggle.btn-xs:focus.active,
.btn-toggle.btn-xs.focus.active {
  outline: none;
}
.btn-toggle.btn-xs:before,
.btn-toggle.btn-xs:after {
  line-height: 1rem;
  width: 0;
  text-align: center;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 0;
  transition: opacity 0.25s;
}
.btn-toggle.btn-xs:before {
  content: 'Off';
  left: 0;
}
.btn-toggle.btn-xs:after {
  content: 'On';
  right: 0;
  opacity: 0.5;
}
.btn-toggle.btn-xs > .handle {
  position: absolute;
  top: 0.125rem;
  left: 0.125rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.75rem;
  background: #fff;
  transition: left 0.25s;
}
.btn-toggle.btn-xs.active {
  transition: background-color 0.25s;
}
.btn-toggle.btn-xs.active > .handle {
  left: 1.125rem;
  transition: left 0.25s;
}
.btn-toggle.btn-xs.active:before {
  opacity: 0.5;
}
.btn-toggle.btn-xs.active:after {
  opacity: 1;
}
.btn-toggle.btn-xs.btn-sm:before,
.btn-toggle.btn-xs.btn-sm:after {
  line-height: -1rem;
  color: #fff;
  letter-spacing: 0.75px;
  left: 0.275rem;
  width: 1.55rem;
}
.btn-toggle.btn-xs.btn-sm:before {
  text-align: right;
}
.btn-toggle.btn-xs.btn-sm:after {
  text-align: left;
  opacity: 0;
}
.btn-toggle.btn-xs.btn-sm.active:before {
  opacity: 0;
}
.btn-toggle.btn-xs.btn-sm.active:after {
  opacity: 1;
}
.btn-toggle.btn-xs.btn-xs:before,
.btn-toggle.btn-xs.btn-xs:after {
  display: none;
}
.btn-toggle.btn-secondary {
  color: #6b7381;
  background: #bdc1c8;
}
.btn-toggle.btn-secondary:before,
.btn-toggle.btn-secondary:after {
  color: #6b7381;
}
.btn-toggle.btn-secondary.active {
  background-color: #ff8300;
}

.pa-items-center { text-align:center;}

ul.iq-edit-profile .nav-link.active {
    color: #dfe0ff!important;
    background: #0e4372 !important;
}
ul.iq-edit-profile .nav-link {
    border-radius: 8px 0 0 8px!important;
}
.iq-edit-profile .col-md-3:last-child .nav-link {
border-radius: 0 8px 8px 0!important;
}
.profile-img-edit { text-align:center;}
.crm-profile-img-edit {height: 100px;
    width: 100px;
    line-height: 100px;
    min-width: 100px;
	display:block;
	    margin: 0 auto;
    position: relative;
	}
body,
p,
.btn,
.iq-sidebar-menu .iq-menu li a {font-size:14px !important;}
.datepicker table tr td, .datepicker table tr th {
    text-align: center;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}

.pa-pdf-icon { position:absolute; top: 50%;
    right: 36px; z-index:9998;
  transform: translate(-50%, -50%);	
	}
.pa-pdf-icon img { width:60px;}
.iq-navbar-custom .d-flex.align-items-center .change-mode,
.iq-navbar-custom .nav-item.nav-icon.dropdown
{display:none !important;}
.iq-navbar-custom .nav-item.nav-icon.dropdown.caption-content {display:block !important;}

.iq-navbar-custom {
    margin-top: 20px;
}
.iq-sidebar {
    position: fixed;
    z-index: 99999 !important;
}
.tg  {border-collapse:collapse;border-spacing:0; margin-bottom:0 !important;}
.tg td{font-size:12px;    text-align: left; font-weight:600;
  overflow:hidden;padding:15px 6px;word-break:normal; position:relative;}
.tg th{border-color:black;border-style:solid;border-width:1px;font-family:Arial, sans-serif;font-size:14px;
  font-weight:normal;overflow:hidden;padding:10px 5px;word-break:normal;}
.tg .tg-0lax{text-align:left;vertical-align:top}
.tg .tg-0lax1 {
    font-weight: 500;
}
.tg th.border, .tg td.border {
    border: 1px solid #dee2e6;
}

.tg td td {
    padding: 0px 0px;
}
.table-bordered.color-preface .color-preface.text-center td {
    border: 1px solid #295883;
}
.color-preface.text-center td {text-align:center;}
.tg .color-gray {background:#F5F5F6;}
.tg .color-gray1{background:#F9F9F9;}
.tg .color-gray2{background:#d2d9e3; color: #000; font-weight:600;}
.tg .color-lred {background:#fefeff}
.tg .color-green {background: #e2f1e8;color: #70a785;}
.tg .color-preface {background: #F37920;color: #fff;}
.tg .color-violet{background:#f7f4fd; color: #000;}
.tg .color-gray3 {background: #fcfbfd;}
.tg .color-white {background:#fff;}
.tg .color-heading{background: #eff2f3;
    color: #1e4466;
	}
.tg .fix-height{ padding:0 15px;}
.pl-0{padding-left:0 !important;}
.pr-0 {padding-right:0 !important;}
.tg .fix-height .td-0lax-h{padding:15px 15px;}
.bold-font {font-weight:600;}
.tg-row li {border-bottom:1px solid #f7f7f7;}
.inline-block-icon { margin-left:10px;font-size:13px;}
.pa-1w{width:30%;}
.pa-num-w{width:10%;}
.pa-num-w15{width:15%;}
.pa-1w7 {
    width: 7%;
}
.pa-1w1 {width: 1%;}
.tg-row {margin:0; padding:0; list-style:none;}
/* popover */

.my-popover-btn {
  --ui-popover-placement: top;
}

.d-none {
  display: none
}
.pa-popover {display: inline;
    position: relative; font-weight:600;}
	.pa-amount-wrap { background:#eee;}
.pa-popover:hover {cursor:pointer;}
.inline-block {display: inline;
    position: relative;}
.pa-preview-wrap i {font-size:20px;}
.valid-feedback-wrap { margin-top:10px; font-size:12px;}
.webui-popover .webui-popover-content {
    padding: 9px 14px;
    overflow: auto;
    display: block;
    width: 100%;
}
.webui-popover {
    min-width: 350px;
}
.pa-close,
.pa-edit-btn { display:inline-block; width:30px; height:30px; border-radius:50%;}
.content-tabs {
  border: 1px solid #efefef;
  box-shadow: 5px 5px 20px rgba(255, 255, 255, 0.3);
  margin-top: 30px;
  width: 400px;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.content-tabs .tab-content {
  padding: 0px 20px;
  min-height: 300px;
}
.content-tabs .tab-content h3 i {
  color: #f15009;
}
.content-tabs .tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin: 0px;
  height: 55px;
  overflow: hidden;
  background: #fff;
}
.content-tabs .tabs li {
  display: inline-block;
}
.content-tabs .tabs li a {
  background: transparent;
  text-align: center;
  transform: translate(0px, 17px);
  display: block;
  text-decoration: none;
  padding: 0px 20px;
  transition: all 0.5s ease-out;
}
.content-tabs .tabs li a .icon {
  display: block;
  margin-bottom: 15px;
  color: #f15009;
  font-size: 20px;
}
.content-tabs .tabs li a span {
  display: block;
  position: relative;
  color: #f15009;
  font-size: 15px;
  font-weight: 600;
}
.content-tabs .tabs li a span:before {
  content: "";
  position: absolute;
  background: #f15009;
  bottom: -14px;
  right: 0;
  left: 0;
  margin: 0px auto;
  border-radius: 100px;
  height: 3px;
  width: 3px;
  transition: all 0.5s ease-out;
}
.content-tabs .tabs li:hover a {
  transform: translate(0px, -25px);
}
.content-tabs .tabs li.active a {
  transform: translate(0px, -25px);
}
.content-tabs .tabs li.active a span:before {
  height: 3px;
  width: 30px;
}

/* ========================== Accordion ==========================*/
#accordionGSTR .btn-link,
#accordionGSTR .btn-link:hover,
#accordionGSTR .btn-link:active {
    font-weight: 600;
    color: #000000!important;
    text-decoration: none;
    font-size: 20px !important;
}
#accordionGSTR .btn-link
{
    border-bottom: 1px solid #ddd;
	}
#accordionGSTR .btn-link i {
    position: absolute;
    right: 20px;
}
.pa-gstr-acc .card-header {    padding: 4px 20px 20px 20px !important;}
.gstr-tab a {font-size:13px; font-weight:600}
.datepicker .form-control {
	padding-left: 35px !important;
    padding-top: 9px;
}
.pf-h-icon-box .iq-thumb {position: absolute;width: 50px; height: 50px; background: #ffffff00;left: 18px;top: 11px;}
.pf-h-icon-box {text-align: left !important;padding-left: 40px;adding-top: 10px; margin-bottom:25px;min-height: 80px;}	
.pf-h-icon-box h6{ margin-top: 10px;}
/* ========================== Accordion ==========================*/
.pa-choose-date .datepicker {
    z-index: 9990 !important;
    text-align: left;
}
.datepicker-dropdown.dropdown-menu {
    margin:10px 0 0 23px !important;
}
.tab-content {
    text-align: left;
	padding-left:0px;
}
.r-list-group .list-group-item {
    padding: 0.75rem 0rem;font-size: 12px;
}
.r-list-group .list-group-item .las {margin:0 5px 0 0 !important;    
font-size: 20px;
top: 2px;
position: relative;
}
.r-list-group .list-group-item a {
    color: #000000;
    text-decoration: none;
}
.pa-text-danger {
    color: #ff4545 !important;
}
.pa-text-success {color: #0ca940 !important;}
.pa-text-info {color: #0263D1 !important;}
.input-form {    position: relative;}
.mx-calendar-panel-year .mx-icon-double-right::before,
.mx-calendar-panel-year .mx-icon-double-left::before {
  display: none;
}
.iq-top-navbar { z-index: 9999;}
.iq-search-bar .pa-choose-date label {padding:6px 0 0 0 !important; text-align: right;font-size: 12px;}
.iq-search-bar .pa-choose-date .row{margin-right: 0px; margin-left:0px;}
.iq-search-bar .pa-choose-date .form-group {
    margin-bottom: 0;
}
.iq-search-bar .pa-welcome-notifi {
    margin-bottom: 0;
    font-size: 20px !important;
}
.iq-search-bar .form-control {
    height: 30px;
    line-height: 18px;
    border: 1px solid #f1f1f1;
    font-size: 14px;
    border-radius: 4px;
}
.iq-search-bar .input-group-addon {
    position: absolute;
    top: 7%;
    left: 25px;
    font-size: 18px;
}
.gstr-tab {
    margin-top: -10px;
}
.pa-nav-tabs-1{border-bottom: 1px solid #f7f7f7;}
.pa-nav-tabs-1 .nav-link.active, .pa-nav-tabs-1 .nav-item.show .nav-link,
.pa-nav-tabs-1 .nav-item .nav-link:hover
 {
    background-color: #F37920!important;
	border-bottom: 1px solid #f7f7f7;
	color: #fff !important;
}
.pa-nav-tabs-1 .nav-link {margin-right:5px;
border-radius: 35px;
    position: relative;
	border-bottom: 1px solid #f7f7f7 !important;
}
.pa-nav-tabs-1 .nav-link.active{position:relative;}
.pa-nav-tabs-1 .nav-link:hover:before,
.pa-nav-tabs-1 .nav-link.active:before{position:absolute;
    content: "";
    margin:0 0.5em;
    display:inline-block;
    border: 7px solid transparent;
    border-top: 8px solid #F37920;
    border-bottom: 0 none;
    bottom: -8px;
    left: 37%;
}
.pa-nav-tabs-2 .nav-link {position:relative; margin-right:10px;}
.pa-nav-tabs-2 .nav-link.active {background:#333;color:#fff; }
.pa-nav-tabs-2 .nav-link:hover {background:#333;color:#fff !important;}
.pa-nav-icon-tabs.pa-nav-tabs-2 .nav-link,
.pa-nav-icon-tabs.pa-nav-tabs-2 .nav-link.active {padding-right:30px;}
.pa-check-mark {position:absolute; 
display:inline-block;
top: 8px;
    right: 10px;
    font-size: 14px;
    color: #6bef97;
	display:none
}

.nav-link.active .pa-check-mark{display:block;}
.pa-show-note-count { border-radius:10px;}
.pa-show-note-count .dropdown-menu {position:relative;background:transparent;    float: none; box-shadow:none; border:none;}
.pa-show-note-count .dropdown-menu  li .item {
padding: 5px 10px;
    border-bottom: 1px solid #f1f1f1;
    color: #535f6b;
    font-size: 12px;
    position: relative;
    padding-left: 35px;
    font-weight: 500;
}
.pa-show-note-count .dropdown-menu li {background:transparent;}
.pa-show-note-count li .item i {
padding:7px 8px;
    line-height: 12px;
    margin-right: 8px;
    border-radius: 4px;
    font-size: 12px;    
	position: absolute;
	    left: 0;    
		top: 8px;
}
.pa-show-note-count h2 {
    font-size: 16px;
    font-weight: 600;
    border-top: 1px solid #efeded;
    padding-top: 10px;
    padding-left: 0px;
}
.pa-note-block { margin:20px 0 0 0;}
.pa-show-note-count .item small{display:block;font-weight:400; } 
.nav-tabs .nav-link {
    display: block;
}
.r-list-group-icon li {padding-left: 25px !important;}
.r-list-group-icon li small {display:block;}
.r-list-group-icon .list-group-item .las {
    margin: 0 5px 0 0 !important;
    font-size: 20px;
    position: absolute;
    left: 0;
    top: 15px;
}
.gstr-sidebar { background:#fafafa; border-radius:15px; padding:25px 15px 20px;}
.gstr-sidebar .gstr-tab a {
    font-size: 11px;
    font-weight: 600;
}
.list-group-item {
    padding: 0.75rem 0rem;
    background-color:transparent;
    border: 1px solid #eaebed;
}
.close-data {cursor:pointer;    
background-color: #F37920 !important;
    border-radius: 50%;
    padding: 5px 7px;}
.datepicker-btn {font-size:12px!important;padding: 5px 0.75rem;    border-radius: 5px;}

.pfa-sidebar-acc { position:relative;}
.pfa-sidebar-acc .pfa-header{ padding:12px 10px 8px 10px; 
border-bottom:1px solid #f1f1f1;border-radius:0px;}
.pfa-sidebar-acc .pfa-sidebar-acc-dec{
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    margin-top: -8px;transition: all .3s ease-in-out;
}
.gstr-sidebar h5{font-size: 16px !important; font-weight: 600; border-bottom:1px solid #f1f1f1; margin-bottom:20px;    padding-bottom: 10px;}
.gstr-sidebar h6{font-size: 14px !important; font-weight: 600; padding-left:30px;}
.gstr-sidebar small{ font-size: 11px !important; font-weight: 400;}
.collapsible-link::before {
  content: '';
  width: 14px;
  height: 2px;
  background: #333;
  position: absolute;
  top: calc(50% - 1px);
  right: -14px;
  display: block;
  transition: all 0.3s;
}

/* Vertical line */
.collapsible-link::after {
  content: '';
  width: 2px;
  height: 14px;
  background: #333;
  position: absolute;
  top: calc(50% - 7px);
  right: calc(-9px + 1px);
  display: block;
  transition: all 0.3s;
}

.collapsible-link[aria-expanded='true']::after {
  transform: rotate(90deg) translateX(-1px);
}

.collapsible-link[aria-expanded='true']::before {
  transform: rotate(180deg);
}
.pf-upload-count { position:absolute; left:-40px; width:30px; height:30px; line-height:30px; font-size:14px; font-weight:600;background:#F37920; color:#fff;
text-align:center; border-radius:50%;}
.pf-upload-count.red-bg {background:#F37920;}
.pf-upload-count.blue-bg {background:#F37920;}
.badge-success1,.badge-success1:hover {background:#F37920 !important; color:#fff!important; }
.pa-acc-card-body { background:transparent; padding:0 !important;}
.pfa-down-all { text-align:right; font-size:14px; border-bottom:1px solid #fafafa; padding-bottom:10px; }
.pfa-down-list  li {border-bottom:1px solid #eaebed;}
.pfa-down-list a,.pfa-down-list a:hover { display:block; position:relative;color:#F37920!important;}
.pfa-down-list a span{  position:absolute; right:0;}
.pfa-down-list .pfa-down-list-icon{     width: 20px;
    height: 20px;
    font-size: 14px;
    line-height: 20px;display:inline-block; border-radius:50%; text-align:center; background:#F37920; color:#fff;}
.pa-acc-notes {
color: #F37920!important;
    border-color: #F37920!important;
    background-color: #ffffff!important;
}
.pa-acc-card-body .pfa-down-all .badge {
    padding: 0.3em 0.6em;
    line-height: 1.3;
    text-transform: capitalize;
    border-radius: 4px;
}
/* acc */

/* Bento */
.pa-bento-box{border-radius: 20px; padding:20px;    position: relative; overflow:hidden;}
.mh-bentobox:after {
  background: #fff;
  content: "";
  height: 140%;
  left: -120%;
  opacity: 0.2;
  position: absolute;
  top: -10%;
  transform: rotate(35deg);
  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
  width: 50px;
  z-index: 99;
}

.mh-bentobox:hover:after {
  left: 120%;
  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);
}

.pa-bento-box-1{background:#c4b2e8;}
.pa-bento-box-2{background:#f1dedd;}
.pa-bento-box-3{background:#c4d48c;}
.pa-bento-box-4{background:#ffdf6f;}
.pa-bento-box-5{background:#f9a473;}
.pa-bento-box-6{background:#96b0c3;}
.pa-bento-box-7{background:#4a545e}
.header-title h4 {font-size: 20px !important;}
.pa-bento-box-7 h6 {color: #111;}
.pa-bento-box-7 h4 {color: #fff;}
.iq-thumb {width:60px; height:60px; background:#ffffff3b; border-radius:50% !important; text-align:center; line-height:60px;    margin: 0 auto;}
.iq-thumb img {width:60%; margin:0 auto;}
.header-title{padding-bottom: 10px; border-bottom: 1px solid #ffffff2e;}
.mh-bentobox {min-height: 169px;}
.pa-bento-box .profile-details .media.align-items-center {
    border-bottom: 1px solid #ffffff2e;
    padding-bottom: 10px;
}
.pa-forex-list {margin-top: 5px;
    max-height: 181px;
    overflow: hidden;
overflow-y: scroll;
    padding-right: 15px;	
	}
.pa-bento-box h6 a,	
.pa-bento-box h6 a:hover{color:#fff !important;}
.pa-welcome-notifi span { display:inline-block; position:relative; width:40px; height:40px; line-height:40px; text-align:center; background:#ffffff36; border-radius:50%;}	
.pa-welcome-notifi span i {color:#fff;}
.pa-p-d-small {     font-size: 12px !important;
    color: #ffffff96 !important;}
.pa-p-d-small.italic {font-style:italic;color: #fff !important;
    font-size: 10px !important;}
	.profile-details { max-height:282px; 
	    overflow: hidden;
overflow-y: scroll;
    padding-right: 15px;}
.pa-welcome-notifi {
    margin-bottom: 0px;
	font-size: 18px !important;
    color: #fff;
}	
.mh-bentobox a {display:block;    position: absolute;
left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
	
	}	
.mh-bentobox a h6 {color:#fff !important}	
@media (min-width: 450px) {
      .main-card {
        width: 96%;
        max-width: 400px;
        height: calc(100% - 32px) !important;
        border-radius: 8px !important;
        max-height: 450px;
      margin: 16px!important;
      }
    }

 .main-card.collapsed {
      width: 48px !important;
      height: 48px !important;
      border-radius: 24px !important;
      margin: 16px!important;
	      position: fixed;
    }

.main-card {
      background: white;
      color: white;
      width: 100%;
      height: 100%;
      margin: 0px;
      border-radius: 0px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      right: 0;
      bottom: 0;
      position: fixed;
      transition: all 0.5s;
      box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2),0 6px 20px 0 rgba(0, 0, 0, 0.19);
	  z-index: 99999 !important;
    }
#chatbot_toggle {
  position: absolute;
  right: 0;
  border: none;
  height: 48px;
  width: 48px;
  background: #F37920;
  padding: 14px;
  color:white;
}
#chatbot_toggle:hover {
  background: #111;
}
.line {
  height: 1px;
  background-color: #F37920;
  width: 100%;
  opacity: 0.2;
}
.main-title {
  background-color: #F37920;
  font-size: large;
  font-weight: bold;
  display: flex;
  height: 48px;
}
.main-title>div{
  height:48px;
  width:48px;
  display:flex;
  margin-left:8px;
}
.main-title svg {
  height: 24px;
  margin: auto;
}
.main-title > span {
  margin: auto auto auto 8px;
}
.chat-area {
  flex-grow: 1;
  overflow: auto;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}
.input-message {
  padding: 8px 48px 8px 16px;
  flex-grow: 1;
  border: none;
}
.input-message:focus {
  outline: none;
}
.input-div {
  height: 48px;
  display: flex;
}

.input-send {
  background: transparent;
  width: 48px;
  height: 48px;
  right: 0%;
  border: none;
  cursor: pointer;
}
.input-send:hover {
  background: lavender;
}
.input-send svg {
  fill: #F37920;
  margin: 11px 8px;
}
.chat-message-div {
  display: flex;
}

.chat-message-sent {
  background-color: white;
  margin: 8px 16px 8px 6px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 2px 8px;
  background-color: lavender;
}

.chat-message-received {
  background-color: white;
  margin: 8px 64px 8px 6px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 8px 2px;
  background-color: lavender;
}
.chat-img-wrap img {width:30px;}
.chat-img-wrap span {display:inline-block;}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* chat */
.btn {    border-radius: 4px;}
.content-page {margin-left: 215px;padding: 110px 0px 0px;}
.iq-sidebar {width: 215px;}
.iq-top-navbar {
    width: calc(100% - 215px);
}
@media (max-width: 1299px)
{
.content-page {
    margin-left: 0px;

}
.iq-top-navbar {
    width: 100%;
}
.iq-footer {
    margin-left: 0;
    width: calc(100vw - 215px);
}
}

.iq-footer {
    margin-left: 0px;
    width:100%;
}
.filepond--credits {display:none !important;}

/* chat */
@media (min-width: 450px) {
      .main-card {
        width: 96%;
        max-width: 400px;
        height: calc(100% - 32px) !important;
        border-radius: 8px !important;
        max-height: 450px;
      margin: 16px!important;
      }
    }

 .main-card.collapsed {
      width: 48px !important;
      height: 48px !important;
      border-radius: 24px !important;
      margin: 16px!important;
	      position: fixed;
    }

    .main-card {
      background: white;
      color: white;
      width: 100%;
      height: 100%;
      margin: 0px;
      border-radius: 0px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      right: 0;
      bottom: 0;
      position: absolute;
      transition: all 0.5s;
      box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2),0 6px 20px 0 rgba(0, 0, 0, 0.19);
	  z-index: 99999 !important;
    }
#chatbot_toggle {
  position: absolute;
  right: 0;
  border: none;
  height: 48px;
  width: 48px;
  background: #F37920;
  padding: 14px;
  color:white;
}
#chatbot_toggle:hover {
  background: #111;
}
.line {
  height: 1px;
  background-color: #F37920;
  width: 100%;
  opacity: 0.2;
}
.main-title {
  background-color: #F37920;
  font-size: large;
  font-weight: bold;
  display: flex;
  height: 48px;
}
.main-title>div{
  height:48px;
  width:48px;
  display:flex;
  margin-left:8px;
}
.main-title svg {
  height: 24px;
  margin: auto;
}
.main-title > span {
  margin: auto auto auto 8px;
}
.chat-area {
  flex-grow: 1;
  overflow: auto;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}
.input-message {
  padding: 8px 48px 8px 16px;
  flex-grow: 1;
  border: none;
}
.input-message:focus {
  outline: none;
}
.input-div {
  height: 48px;
  display: flex;
}

.input-send {
  background: transparent;
  width: 48px;
  height: 48px;
  right: 0%;
  border: none;
  cursor: pointer;
}
.input-send:hover {
  background: lavender;
}
.input-send svg {
  fill: #F37920;
  margin: 11px 8px;
}
.chat-message-div {
  display: flex;
}

.chat-message-sent {
  background-color: white;
  margin: 8px 16px 8px 64px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 2px 8px;
  background-color: lavender;
}

.chat-message-received {
  background-color: white;
  margin: 8px 64px 8px 16px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 8px 2px;
  background-color: lavender;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* chat */
.btn {    border-radius: 4px;}
.filepond--credits {display:none !important;}`, "",{"version":3,"sources":["webpack://./src/assets/css/base.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;EACE,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,uCAAuC;EACvC,0CAA0C;EAC1C,uCAAuC;EACvC,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;EACrC,sCAAsC;EACtC,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB;;;AAGF;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;AACA,kDAAkD;IAC9C,iDAAiD;IACjD,8CAA8C;AAClD;AACA;IACI,WAAW;IACX,8CAA8C;IAC9C,0CAA0C;IAC1C,iBAAiB;AACrB;AACA,YAAY,qBAAqB;AACjC,mFAAmF;AACnF;AACA,cAAc;AACd,qBAAqB;AACrB;AACA,SAAS,oCAAoC,CAAC;AAC9C;EACE,sBAAsB;EACtB,6CAA6C,EAAE;AACjD;;;EAGE,sBAAsB;EACtB,gDAAgD,EAAE;;AAEpD;EACE,sBAAsB;EACtB,oCAAoC,EAAE;;AAExC;;;EAGE,sBAAsB;EACtB,iDAAiD,EAAE;;CAEpD,+EAA+E;AAChF,yBAAyB,UAAU,CAAC;AACpC,aAAa,4BAA4B,EAAE,iBAAiB,EAAE,aAAa,CAAC;AAC5E,kBAAkB,iBAAiB,EAAE,QAAQ,EAAE,SAAS,EAAE,oBAAoB,EAAE,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,CAAC;CAClJ,gFAAgF;AACjF;EACE,kDAAkD;EAClD,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,uEAAuE;EACvE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sJAAsJ;EACtJ,yDAA60B;EAC70B,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,uEAAuE;AACzE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,0FAA0F;AAC5F;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uEAAuE;EACvE,mBAAmB;AACrB;CACC,oFAAoF;;AAErF,qBAAqB,kBAAkB,EAAE,yBAAyB,CAAC;AACnE,gBAAgB,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,CAAC;AACrE,sBAAsB,kBAAkB;;AAExC;;AAEA,oBAAoB,yBAAyB;AAC7C,8BAA8B,uBAAuB;AACrD,qBAAqB,sBAAsB;AAC3C,iBAAiB,cAAc,CAAC;AAChC;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA,oBAAoB,WAAW,EAAE,YAAY,EAAE,kBAAkB,CAAC;AAClE;;CAEC,cAAc,CAAC,gBAAgB,CAAC,gBAAgB;IAC7C,cAAc,CAAC;AACnB,kBAAkB,0BAA0B,EAAE,qBAAqB,CAAC,gBAAgB,EAAE,iBAAiB,CAAC;AACxG,kBAAkB,UAAU,EAAE,WAAW,EAAE,iBAAiB,CAAC;;AAE7D,sBAAsB,cAAc,CAAC;AACrC;AACA,wBAAwB;AACxB;AACA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,kCAAkC;IAClC,2BAA2B,EAAE,eAAe;AAChD;AACA;;AAEA;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB,QAAQ,EAAE,UAAU,EAAE,eAAe;AACrC;AACA,4CAA4C,kBAAkB,EAAE,gBAAgB,CAAC;;AAEjF,+EAA+E;AAC/E;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,gBAAgB;AACpB;AACA;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EAIE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAIhB,4BAA4B;AAC9B;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EAIf,4BAA4B;AAC9B;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iBAAiB,CAAC,UAAU;AAC9B;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EAInB,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,qBAAqB;AACvB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA,oCAAoC,cAAc,CAAC,gBAAgB,EAAE,UAAU,EAAE,aAAa,CAAC;AAC/F;IACI,cAAc;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,cAAc;IACZ,cAAc;CACjB,iBAAiB;AAClB;AACA;;EAEE,iBAAiB;EACjB,cAAc;EACd,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;CACZ,iBAAiB;AAClB;AACA,eAAe,cAAc,EAAE,UAAU,EAAE,gBAAgB,CAAC;AAC5D;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EAIf,uBAAuB;AACzB;AACA;;;AAGA,qBAAqB;AACrB;AACA;;AAEA,0BAA0B;AAC1B;AACA,4BAA4B,kBAAkB,EAAE,SAAS,CAAC;AAC1D,+DAA+D,eAAe;AAC9E;;EAEE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB,CAAC,eAAe,EAAE,UAAU;AAC9C;AACA;CACC,UAAU;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;;CAEC,UAAU,CAAC;;AAEZ;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,0DAA0D;AAC5D;AACA;EACE;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE;IACE,kBAAkB;IAClB,gCAAgC;EAClC;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;EAGA;IACE,aAAa;EACf;AAJF;AAMA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE,UAAU;EACV,4BAA4B;AAC9B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0DAA0D;EAC1D,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB,mBAAmB;IACf,iBAAiB;AACrB;AACA;EACE;IACE,2BAA2B;EAC7B;CACD;IACG,eAAe;AACnB;AACA;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;IACV,WAAW;IACX,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;;;AAIA,qFAAqF;AACrF;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;;;;EAIE,WAAW;EACX,mBAAmB;AACrB;AACA,qFAAqF;;AAErF;EACE,aAAa;EACb,mBAAmB;KAChB,yBAAyB;GAC3B,sBAAsB;GACtB,kBAAkB,EAAE,YAAY;EACjC;AACF,kBAAkB,iBAAiB,CAAC;AACpC;GACG,uCAAuC;GACvC,uCAAuC;AAC1C;AACA,0BAA0B,gBAAgB,CAAC;AAC3C,kBAAkB,iBAAiB;AACnC,aAAa;EACX,uBAAuB;EACvB,mBAAmB,CAAC;AACtB,4BAA4B,oBAAoB,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,CAAC;AAC9F,8BAA8B,oBAAoB,EAAE,gBAAgB,CAAC;AACrE,iCAAiC,cAAc,EAAE,gBAAgB,CAAC;AAClE,gBAAgB,cAAc,EAAE,kBAAkB,EAAE,0BAA0B,EAAE,aAAa,EAAE,iBAAiB,CAAC;AACjH,gCAAgC,cAAc,EAAE,kBAAkB,CAAC;AACnE,iCAAiC,UAAU,CAAC;AAC5C,sBAAsB,UAAU,CAAC;AACjC;aACa,cAAc,EAAE,gBAAgB,CAAC;AAC9C,mFAAmF;;AAEnF,uBAAuB,cAAc,EAAE,gBAAgB,EAAE,oBAAoB,CAAC;AAC9E;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB,KAAK,gBAAgB;AACvC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;MACb,cAAc;AACpB;AACA;IACI,UAAU;IACV,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;AACA;EACE,cAAc;EACd,WAAW;AACb,gBAAgB;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;AACA,qCAAqC;AACrC;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;EAEE,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;EAEE,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,OAAO;AACT;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB,iBAAiB,CAAC;;AAErC;IACI,wBAAwB;IACxB,8BAA8B;AAClC;AACA;IACI,oCAAoC;AACxC;AACA;AACA,oCAAoC;AACpC;AACA,oBAAoB,iBAAiB,CAAC;AACtC,uBAAuB,aAAa;IAChC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;CACnB,aAAa;KACT,cAAc;IACf,kBAAkB;CACrB;AACD;;;gCAGgC,yBAAyB,CAAC;AAC1D;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA,eAAe,iBAAiB,EAAE,QAAQ;IACtC,WAAW,EACI,YAAY;EAE7B,gCAAgC;CACjC;AACD,mBAAmB,UAAU,CAAC;AAC9B;;CAEC,uBAAuB,CAAC;AACzB,+DAA+D,wBAAwB,CAAC;;AAExF;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA,MAAM,wBAAwB,CAAC,gBAAgB,EAAE,0BAA0B,CAAC;AAC5E,OAAO,cAAc,KAAK,gBAAgB,EAAE,eAAe;EACzD,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,EAAE,iBAAiB,CAAC;AACxE,OAAO,kBAAkB,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,6BAA6B,CAAC,cAAc;EACxG,kBAAkB,CAAC,eAAe,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;AACxE,aAAa,eAAe,CAAC,kBAAkB;AAC/C;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA,+BAA+B,iBAAiB,CAAC;AACjD,iBAAiB,kBAAkB,CAAC;AACpC,iBAAiB,kBAAkB,CAAC;AACpC,iBAAiB,kBAAkB,EAAE,WAAW,EAAE,eAAe,CAAC;AAClE,iBAAiB,kBAAkB;AACnC,kBAAkB,mBAAmB,CAAC,cAAc,CAAC;AACrD,oBAAoB,mBAAmB,CAAC,WAAW,CAAC;AACpD,kBAAkB,kBAAkB,EAAE,WAAW,CAAC;AAClD,kBAAkB,mBAAmB,CAAC;AACtC,kBAAkB,eAAe,CAAC;AAClC,mBAAmB,mBAAmB;IAClC,cAAc;CACjB;AACD,iBAAiB,cAAc,CAAC;AAChC,MAAM,yBAAyB,CAAC;AAChC,OAAO,0BAA0B,CAAC;AAClC,2BAA2B,iBAAiB,CAAC;AAC7C,YAAY,eAAe,CAAC;AAC5B,YAAY,+BAA+B,CAAC;AAC5C,qBAAqB,gBAAgB,CAAC,cAAc,CAAC;AACrD,OAAO,SAAS,CAAC;AACjB,UAAU,SAAS,CAAC;AACpB,YAAY,SAAS,CAAC;AACtB;IACI,SAAS;AACb;AACA,SAAS,SAAS,CAAC;AACnB,SAAS,QAAQ,EAAE,SAAS,EAAE,eAAe,CAAC;AAC9C,YAAY;;AAEZ;EACE,2BAA2B;AAC7B;;AAEA;EACE;AACF;AACA,aAAa,eAAe;IACxB,kBAAkB,EAAE,eAAe,CAAC;CACvC,kBAAkB,eAAe,CAAC;AACnC,mBAAmB,cAAc,CAAC;AAClC,eAAe,eAAe;IAC1B,kBAAkB,CAAC;AACvB,oBAAoB,cAAc,CAAC;AACnC,uBAAuB,eAAe,EAAE,cAAc,CAAC;AACvD;IACI,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;eACe,oBAAoB,EAAE,UAAU,EAAE,WAAW,EAAE,iBAAiB,CAAC;AAChF;EACE,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA,mEAAmE;AACnE;;;IAGI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;;IAEI,6BAA6B;CAChC;AACD;IACI,kBAAkB;IAClB,WAAW;AACf;AACA,+BAA+B,sCAAsC,CAAC;AACtE,aAAa,cAAc,EAAE,eAAe;AAC5C;CACC,6BAA6B;IAC1B,gBAAgB;AACpB;AACA,0BAA0B,kBAAkB,CAAC,WAAW,EAAE,YAAY,EAAE,qBAAqB,CAAC,UAAU,CAAC,SAAS,CAAC;AACnH,gBAAiC,2BAA2B,CAAC,kBAAkB,CAAC,gBAAgB,EAAE,kBAAkB,CACpG,gBAAgB,CADqF;AAErH,mBAAmB,gBAAgB,CAAC;AACpC,mEAAmE;AACnE;IACI,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,gBAAgB;CACnB,gBAAgB;AACjB;AACA;IACI,qBAAqB,CAAC,eAAe;AACzC;AACA,qCAAqC,2BAA2B;AAChE,eAAe;AACf,QAAQ;AACR,kBAAkB;AAClB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA,kBAAkB,yBAAyB,CAAC;AAC5C,eAAe,yBAAyB,CAAC;AACzC,iBAAiB,kBAAkB,CAAC;AACpC;;EAEE,aAAa;AACf;AACA,iBAAiB,aAAa,CAAC;AAC/B,sCAAsC,4BAA4B,EAAE,iBAAiB,CAAC,eAAe,CAAC;AACtG,oCAAoC,iBAAiB,EAAE,eAAe,CAAC;AACvE;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA,eAAe,gCAAgC,CAAC;AAChD;;;IAGI,mCAAmC;CACtC,gCAAgC;CAChC,sBAAsB;AACvB;AACA,0BAA0B,gBAAgB;AAC1C,mBAAmB;IACf,kBAAkB;CACrB,2CAA2C;AAC5C;AACA,gCAAgC,iBAAiB,CAAC;AAClD;uCACuC,iBAAiB;IACpD,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,6BAA6B;IAC7B,6BAA6B;IAC7B,qBAAqB;IACrB,YAAY;IACZ,SAAS;AACb;AACA,0BAA0B,iBAAiB,EAAE,iBAAiB,CAAC;AAC/D,iCAAiC,eAAe,CAAC,UAAU,EAAE;AAC7D,gCAAgC,eAAe,CAAC,qBAAqB,CAAC;AACtE;kDACkD,kBAAkB,CAAC;AACrE,gBAAgB,iBAAiB;AACjC,oBAAoB;AACpB,QAAQ;IACJ,WAAW;IACX,eAAe;IACf,cAAc;CACjB;AACD;;AAEA,gCAAgC,aAAa,CAAC;AAC9C,sBAAsB,kBAAkB,CAAC;AACzC,oCAAoC,iBAAiB,CAAC,sBAAsB,KAAK,WAAW,EAAE,eAAe,EAAE,WAAW,CAAC;AAC3H;AACA,iBAAiB;IACb,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,uCAAuC,sBAAsB,CAAC;AAC9D;AACA,eAAe;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;CAClB,kBAAkB;KACd,OAAO;EACV,QAAQ;AACV;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;AACrB;AACA,iBAAiB,iBAAiB,CAAC;AACnC,gCAAgC,aAAa,CAAC,eAAe,EAAE;AAC/D;IACI,cAAc;AAClB;AACA,uBAAuB,6BAA6B,CAAC;AACrD,6BAA6B,aAAa,CAAC;AAC3C;IACI,4BAA4B;IAC5B,eAAe;IAEf,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;AACA,gBAAgB,kBAAkB,EAAE,kBAAkB,EAAE,sBAAsB,CAAC;AAC/E;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA,aAAa,cAAc;AAC3B,oCAAoC;IAChC,kBAAkB;IAClB,gBAAgB,CAAC;AACrB,iBAAiB,wBAAwB,CAAC,oBAAoB,KAAK,kBAAkB,CAAC;;AAEtF,mBAAmB,iBAAiB,CAAC;AACrC,8BAA8B,0BAA0B;AACxD,+BAA+B,CAAC,iBAAiB,CAAC;AAClD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gBAAgB,CAAC,+BAA+B;AACpD;AACA,iBAAiB,0BAA0B,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,kBAAkB,KAAK,oBAAoB,CAAC;AAC5I,iBAAiB,0BAA0B,EAAE,gBAAgB,EAAE,iBAAiB,CAAC;AACjF,qBAAqB,0BAA0B,EAAE,gBAAgB,CAAC;AAClE;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;AACA,mBAAmB,iBAAiB,EAAE,UAAU,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,CAAC,kBAAkB,EAAE,UAAU;AAC3J,iBAAiB,EAAE,iBAAiB,CAAC;AACrC,yBAAyB,kBAAkB,CAAC;AAC5C,0BAA0B,kBAAkB,CAAC;AAC7C,uCAAuC,6BAA6B,EAAE,oBAAoB,EAAE;AAC5F,oBAAoB,sBAAsB,EAAE,oBAAoB,CAAC;AACjE,gBAAgB,gBAAgB,EAAE,cAAc,EAAE,+BAA+B,EAAE,mBAAmB,EAAE;AACxG,oBAAoB,+BAA+B,CAAC;AACpD,0CAA0C,aAAa,EAAE,iBAAiB,CAAC,uBAAuB,CAAC;AACnG,wBAAwB,iBAAiB,EAAE,OAAO,CAAC;AACnD,wCAAwC,WAAW;IAC/C,YAAY;IACZ,eAAe;IACf,iBAAiB,CAAC,oBAAoB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,UAAU,CAAC;AACjH;AACA,wBAAwB;IACpB,+BAA+B;IAC/B,mCAAmC;AACvC;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;IAK1B,kBAAkB;AACtB;AACA,QAAQ;;AAER,UAAU;AACV,cAAc,mBAAmB,EAAE,YAAY,KAAK,kBAAkB,EAAE,eAAe,CAAC;AACxF;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,oDAAoD;EACpD,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oDAAoD;AACtD;;AAEA,gBAAgB,kBAAkB,CAAC;AACnC,gBAAgB,kBAAkB,CAAC;AACnC,gBAAgB,kBAAkB,CAAC;AACnC,gBAAgB,kBAAkB,CAAC;AACnC,gBAAgB,kBAAkB,CAAC;AACnC,gBAAgB,kBAAkB,CAAC;AACnC,gBAAgB,kBAAkB;AAClC,kBAAkB,0BAA0B,CAAC;AAC7C,oBAAoB,WAAW,CAAC;AAChC,oBAAoB,WAAW,CAAC;AAChC,WAAW,UAAU,EAAE,WAAW,EAAE,oBAAoB,EAAE,4BAA4B,EAAE,iBAAiB,EAAE,gBAAgB,KAAK,cAAc,CAAC;AAC/I,eAAe,SAAS,EAAE,aAAa,CAAC;AACxC,cAAc,oBAAoB,EAAE,kCAAkC,CAAC;AACvE,cAAc,iBAAiB,CAAC;AAChC;IACI,kCAAkC;IAClC,oBAAoB;AACxB;AACA,gBAAgB,eAAe;IAC3B,iBAAiB;IACjB,gBAAgB;AACpB,kBAAkB;IACd,mBAAmB;CACtB;AACD;yBACyB,qBAAqB,CAAC;AAC/C,0BAA0B,oBAAoB,EAAE,iBAAiB,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,iBAAiB,CAAC;AACzK,2BAA2B,UAAU,CAAC;AACtC,oBAAoB,0BAA0B;IAC1C,2BAA2B,CAAC;AAChC,sBAAsB,iBAAiB,CAAC,sBAAsB;IAC1D,0BAA0B,CAAC;CAC9B,mBAAmB,gBAAgB;KAC/B,gBAAgB;AACrB,kBAAkB;IACd,mBAAmB,CAAC;AACxB;IACI,kBAAkB;CACrB,0BAA0B;IACvB,WAAW;AACf;AACA,gBAAgB,aAAa,KAAK,kBAAkB;AACpD,SAAS;IACL,QAAQ;IAER,gCAAgC;;CAEnC;AACD,mBAAmB,qBAAqB;AACxC;MACM;QACE,UAAU;QACV,gBAAgB;QAChB,oCAAoC;QACpC,6BAA6B;QAC7B,iBAAiB;MACnB,sBAAsB;MACtB;IACF;;CAEH;MACK,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,sBAAsB;OACrB,eAAe;IAClB;;AAEJ;MACM,iBAAiB;MACjB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,QAAQ;MACR,SAAS;MACT,eAAe;MACf,oBAAoB;MACpB,6EAA6E;GAChF,yBAAyB;IACxB;AACJ;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA,oBAAoB,UAAU,CAAC;AAC/B,qBAAqB,oBAAoB,CAAC;;AAE1C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,SAAS;AACT,UAAU,kBAAkB,CAAC;AAC7B,eAAe,kBAAkB,CAAC,sBAAsB,CAAC;AACzD,aAAa,YAAY,CAAC;AAC1B;IACI,yBAAyB;AAC7B;AACA;;AAEA;IACI,gBAAgB;;AAEpB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA,oBAAoB,uBAAuB,CAAC;;AAE5C,SAAS;AACT;MACM;QACE,UAAU;QACV,gBAAgB;QAChB,oCAAoC;QACpC,6BAA6B;QAC7B,iBAAiB;MACnB,sBAAsB;MACtB;IACF;;CAEH;MACK,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,sBAAsB;OACrB,eAAe;IAClB;;IAEA;MACE,iBAAiB;MACjB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,QAAQ;MACR,SAAS;MACT,kBAAkB;MAClB,oBAAoB;MACpB,6EAA6E;GAChF,yBAAyB;IACxB;AACJ;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,SAAS;AACT,UAAU,kBAAkB,CAAC;AAC7B,oBAAoB,uBAAuB,CAAC","sourcesContent":["/*!\n*\n* Base stylesheet\n* Author: PJ\n* Design and Developed by: PJ\n* NOTE: This file contains the styling for responsive Template.\n*\n*/\n\n:root {\n  --pf-primary: #F37920;\n  --pf-secondary: #ccced2;\n  --pf-success: #b7e1ba;\n  --pf-info: #ffe6de;\n  --pf-warning: #ffebdf;\n  --pf-danger: #ffdaeb;\n  --pf-light: #FAFAFA;\n  --pf-dark: rgba(199, 203, 211, 0.1);\n  --pf-orange: #ffdcd8;\n  --pf-purple: #cbc0ff;\n  --pf-pink: #fff1f1;\n  --pf-primary-t: rgba(71, 136, 255, 0.1);\n  --pf-secondary-t: rgba(108, 117, 125, 0.1);\n  --pf-success-t: rgba(55, 230, 178, 0.1);\n  --pf-info-t: rgba(135, 108, 254, 0.1);\n  --pf-warning-t: rgba(254, 114, 28, 0.1);\n  --pf-danger-t: rgba(255, 75, 75, 0.1);\n  --pf-light-t: rgba(199, 203, 211, 0.1);\n  --pf-dark-t: rgba(1, 4, 27, 0.1);\n  --pf-orange-t: rgba(253, 126, 20, 0.1);\n  --pf-purple-t: rgba(71, 49, 182, 0.1); \n  --c-grey-100: #f4f6f8;\n  --c-grey-200: #e3e3e3;\n  --c-grey-300: #b2b2b2;\n  --c-grey-400: #7b7b7b;\n  --c-grey-500: #3d3d3d;\n  --c-blue-500: #688afd;\n  }\n\n\n.login-content .pf-sign-user_card {\n    padding: 30px;\n    border:none !important;\n    text-align: center;\n    border-radius: 8px;\n}\n.pf-shadow{\n-ms-box-shadow: 0 16px 40px 0 rgba(0,0,0,.0392157);\n    -o-box-shadow: 0 16px 40px 0 rgba(0,0,0,.0392157);\n    box-shadow: 0 16px 40px 0 rgba(0,0,0,.0392157);\t\n}\n.btn-primary {\n    color: #fff;\n    background-color: var(--pf-primary) !important;\n    border-color: var(--pf-primary) !important;\n    box-shadow: unset;\n}\n.btn:hover {color:#fff !important}\n/* ================================== Elements ================================== */\na {\ncolor: #F37920;\ntext-decoration: none;\n}\na:hover {color:rgba(15,67,144,0.7) !important;}\n.bg-primary {\n  color: #fff !important;\n  background-color:var(--pf-primary) !important; }\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  color: #fff !important;\n  background-color: rgba(15,67,144,0.7) !important; }\n\n.badge-primary {\n  color: #fff !important;\n  background-color: #145886 !important; }\n\na.badge-primary:hover, a.badge-primary:focus,\nbutton.badge-primary:hover,\nbutton.badge-primary:focus {\n  color: #fff !important;\n  background-color:  rgba(15,67,144,0.7) !important; } \n  \n /* ================================== Menu ================================== */\n.pa-s-navmenu .img-nav i{width:30px;}\n.pf-sign-or {border-bottom:1px solid #ddd; position:relative; margin:30px 0;}\n.pf-sign-or span {position:absolute; left:50%; top:-20px; display:inline-block; padding:5px; background:#fff; text-align:center; border-radius:50%;}\n /* ================================== Login ================================== */\n.login-with-google-btn {\n  transition: background-color 0.3s, box-shadow 0.3s;\n  padding: 12px 16px 12px 42px;\n  border: none;\n  border-radius: 35px;\n  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);\n  color: #757575;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);\n  background-color: white;\n  background-repeat: no-repeat;\n  background-position: 12px 11px;\n}\n.login-with-google-btn:hover {\n  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25);\n}\n.login-with-google-btn:active {\n  background-color: #eeeeee;\n}\n.login-with-google-btn:focus {\n  outline: none;\n  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc;\n}\n.login-with-google-btn:disabled {\n  filter: grayscale(100%);\n  background-color: #ebebeb;\n  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);\n  cursor: not-allowed;\n}\n /* ================================== Dashboard ================================== */\n\n.pa-welcome-notifi { margin-bottom:20px; font-size:20px !important;}\n.pf-h-icon-box{ transition: 0.3s; background:#ddd; border-radius:8px;}\n.pf-h-icon-box:hover {background:#ececf7;\n\n}\n\n.pf-download-noti { padding:0 20px !important}\n#fx-pricing-widget-copyright {display:none !important}\n.pf-h-icon-box img { height:40px !important}\n.pa-forex-list { margin-top:5px;}\n.pa-forex-list a {\n    border-bottom:1px solid #ffffff4f;\n    padding: 10px 0px 0;\n}\n\n.pa-forex-list img {width: 25px; height: 25px; margin-right: 15px;}\n.pa-forex-list h2,\n.pa-forex-list h3\n{font-size:14px;text-align: left;margin-bottom: 0;\n    line-height: 1;}\n.pa-forex-list p {font-size: 12px !important; color:#000 !important;text-align: left; margin-bottom:2px;}\n.pa-cforex-flag { width:28px; height:28px; border-radius:50%;}\n\n.pa-upload-wrap h2s { font-size:20px;}\n.datepicker {\nz-index:99990 !important;\n}\n.filepond--panel-root {\n    border-radius: .5em;\n    background-color: #fff;\n}\n.filepond--panel.filepond--panel-root {\n    border: 2px dashed #eee !important;\n    background: #fff !important; overflow:hidden;\n}\n.filepond--panel-bottom, .filepond--panel-top {\n \n}\n.filepond--root .filepond--drop-label {\n    min-height: 10em;\n}\n.input-group-addon{\n    position: absolute;\ntop: 50%; left: 25px; font-size: 23px;\n}\n.pa-upload-wrap .datepicker .form-control { padding-left: 35px; padding-top: 9px;}\n\n/* ================================== CHAT ================================== */\n#pa-chatframe {\n  width: 100%;\n  min-width: 360px;\n  max-width: 100%;\n  height: 92vh;\n  min-height: 300px;\n  max-height: 720px;\n  background: #E6EAEA;\n  border-radius: 10px;\n  overflow:hidden;\n}\n@media screen and (max-width: 360px) {\n  #pa-chatframe {\n    width: 100%;\n    height: 100vh;\n  }\n  .pa-welcome-notifi {\n    margin-top: 20px;\n}\n.iq-top-navbar .navbar-toggler {\n    color: #e1e2ff;\n    background: #F37920;\n}\n.wrapper-menu {\n    color: #F37920;\n}\n}\n#pa-chatframe #sidepanel {\n  float: left;\n  min-width: 280px;\n  max-width: 340px;\n  width: 40%;\n  height: 100%;\n  background: #f3f5f7;\n  box-shadow: 0px 20px 38px 0px rgb(188 196 227 / 63%);\n  color: #f5f5f5;\n  overflow: hidden;\n  position: relative;\n  border-radius: 10px 0 0 10px;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel {\n    width: 58px;\n    min-width: 58px;\n  }\n  .pa-welcome-notifi {\n    margin-top: 30px;\n}\n}\n#pa-chatframe #sidepanel #profile {\n  width: 80%;\n  margin: 25px auto 0px auto;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile {\n    width: 100%;\n    margin: 0 auto;\n    padding: 5px 0 0 0;\n    background: #32465a;\n  }\n}\n#pa-chatframe #sidepanel #profile.expanded .wrap {\n  height: 210px;\n  line-height: initial;\n}\n#pa-chatframe #sidepanel #profile.expanded .wrap p {\n  margin-top: 20px;\n}\n#pa-chatframe #sidepanel #profile.expanded .wrap i.expand-button {\n  -moz-transform: scaleY(-1);\n  -o-transform: scaleY(-1);\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n#pa-chatframe #sidepanel #profile .wrap {\n  height: 60px;\n  line-height: 60px;\n  overflow: hidden;\n  -moz-transition: 0.3s height ease;\n  -o-transition: 0.3s height ease;\n  -webkit-transition: 0.3s height ease;\n  transition: 0.3s height ease;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap {\n    height: 55px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap img {\n  width: 50px;\n  border-radius: 50%;\n  padding: 3px;\n  border: 2px solid #e74c3c;\n  height: auto;\n  float: left;\n  cursor: pointer;\n  -moz-transition: 0.3s border ease;\n  -o-transition: 0.3s border ease;\n  -webkit-transition: 0.3s border ease;\n  transition: 0.3s border ease;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap img {\n    width: 40px;\n    margin-left: 4px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap img.online {\n  border: 2px solid #2ecc71;\n}\n#pa-chatframe #sidepanel #profile .wrap img.away {\n  border: 2px solid #f1c40f;\n}\n#pa-chatframe #sidepanel #profile .wrap img.busy {\n  border: 2px solid #e74c3c;\n}\n#pa-chatframe #sidepanel #profile .wrap img.offline {\n  border: 2px solid #95a5a6;\n}\n#pa-chatframe #sidepanel #profile .wrap p {\n  float: left;\n  margin-left: 15px;color:#000;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap p {\n    display: none;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap i.expand-button {\n  float: right;\n  margin-top: 23px;\n  font-size: 0.8em;\n  cursor: pointer;\n  color: #435f7a;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap i.expand-button {\n    display: none;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options {\n  position: absolute;\n  opacity: 0;\n  visibility: hidden;\n  width: 150px;\n  margin: 70px 0 0 0;\n  border-radius: 6px;\n  z-index: 99;\n  line-height: initial;\n  background: #435f7a;\n  -moz-transition: 0.3s all ease;\n  -o-transition: 0.3s all ease;\n  -webkit-transition: 0.3s all ease;\n  transition: 0.3s all ease;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options {\n    width: 58px;\n    margin-top: 57px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options.active {\n  opacity: 1;\n  visibility: visible;\n  margin: 75px 0 0 0;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options.active {\n    margin-top: 62px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options:before {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 8px solid #435f7a;\n  margin: -8px 0 0 24px;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options:before {\n    margin-left: 23px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul {\n  overflow: hidden;\n  border-radius: 6px;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li {\n  padding: 15px 0 30px 18px;\n  display: block;\n  cursor: pointer;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options ul li {\n    padding: 15px 0 35px 22px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li:hover {\n  background: #496886;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin: 5px 0 0 0;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle {\n    width: 14px;\n    height: 14px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle:before {\n  content: \"\";\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: -3px 0 0 -3px;\n  background: transparent;\n  border-radius: 50%;\n  z-index: 0;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options ul li span.status-circle:before {\n    height: 18px;\n    width: 18px;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li p {\n  padding-left: 12px;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #profile .wrap #status-options ul li p {\n    display: none;\n  }\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-online span.status-circle {\n  background: #2ecc71;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-online.active span.status-circle:before {\n  border: 1px solid #2ecc71;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-away span.status-circle {\n  background: #f1c40f;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-away.active span.status-circle:before {\n  border: 1px solid #f1c40f;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-busy span.status-circle {\n  background: #e74c3c;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-busy.active span.status-circle:before {\n  border: 1px solid #e74c3c;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-offline span.status-circle {\n  background: #95a5a6;\n}\n#pa-chatframe #sidepanel #profile .wrap #status-options ul li#status-offline.active span.status-circle:before {\n  border: 1px solid #95a5a6;\n}\n#pa-chatframe #sidepanel #profile .wrap #expanded {\n  padding: 100px 0 0 0;\n  display: block;\n  line-height: initial !important;\n}\n#pa-chatframe #sidepanel #profile .wrap #expanded label {\n  float: left;\n  clear: both;\n  margin: 0 8px 5px 0;\n  padding: 5px 0;\n}\n#pa-chatframe #sidepanel #profile .wrap #expanded input {\n  border: none;\n  margin-bottom: 6px;\n  background: #32465a;\n  border-radius: 3px;\n  color: #f5f5f5;\n  padding: 7px;\n  width: calc(100% - 43px);\n}\n#pa-chatframe #sidepanel #profile .wrap #expanded input:focus {\n  outline: none;\n  background: #435f7a;\n}\n#pa-chatframe #sidepanel #g-chat {\n  border-top: 1px solid #32465a;\n  border-bottom: 1px solid #32465a;\n  font-weight: 300;\n  margin:0 20px 20px 24px;\n  padding-bottom:60px;\n  position:relative;\n}\n#pa-chatframe #sidepanel #g-chat h2{font-size:14px;font-weight:bold; color:#000; margin:15px 0;}\n#pa-chatframe #sidepanel #g-chat label {\n    color: #7c81a3;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #g-chat {\n    display: none;\n  }\n}\n#pa-chatframe #sidepanel #g-chat label {\n  position: absolute;\n  margin: 10px 0 0 20px;\n}\n#pa-chatframe #sidepanel #g-chat textarea {\n  padding:15px;\n  font-size: 13px;\n  width: 100%;\n  border: none;\n  background: #dee2e5;\n  color: #000;\n  margin: 0 auto;\n    display: block;\n\tborder-radius:8px;\n}\n#pa-chatframe #sidepanel #g-chat button\n {\n  position:absolute;\n  margin-top:5px;\n  right:0;\n  border: none;\n  width: 40px;\n  height:40px;\n  text-align:center;\n  cursor: pointer;\n  background: #04AA6D;\n  color: #fff;\n border-radius:50%;\n}\n.choose-clent {font-size:14px; color:#000; margin-left:24px;}\n#pa-chatframe #sidepanel #g-chat input:focus {\n  outline: none;\n  background: #435f7a;\n}\n#pa-chatframe #sidepanel #g-chat input::-webkit-input-placeholder {\n  color: rgba(255,255,255,0.5);\n}\n#pa-chatframe #sidepanel #g-chat input::-moz-placeholder {\n  color:rgba(255,255,255,0.5);\n}\n#pa-chatframe #sidepanel #g-chat input:-ms-input-placeholder {\n  color:rgba(255,255,255,0.5);\n}\n#pa-chatframe #sidepanel #g-chat input:-moz-placeholder {\n  color:rgba(255,255,255,0.5);\n}\n#pa-chatframe #sidepanel #contacts {\n  height: calc(100% - 130px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #contacts {\n    height: calc(100% - 149px);\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n  #pa-chatframe #sidepanel #contacts::-webkit-scrollbar {\n    display: none;\n  }\n}\n#pa-chatframe #sidepanel #contacts.expanded {\n  height: calc(100% - 334px);\n}\n#pa-chatframe #sidepanel #contacts::-webkit-scrollbar {\n  width: 8px;\n  background: #2c3e50;\n}\n#pa-chatframe #sidepanel #contacts::-webkit-scrollbar-thumb {\n  background-color: #243140;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact {\n  position: relative;\n  padding: 10px 15px 15px 15px;\n  margin-bottom:15px;\n  background:#eee;\n  border-radius:15px;\n  font-size: 0.9em;\n  cursor: pointer;\n    -moz-transition: 1s all ease;\n  -o-transition: 1s all ease;\n  -webkit-transition: 1s all ease;\n  transition: 1s all ease;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact:hover .name,\n#pa-chatframe #sidepanel #contacts ul li.contact:hover .preview\n{\ncolor:#fff !important;\t\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .preview\n{\nfont-size: 12px !important;\n}\n#pa-chatframe #contacts ul {margin:0 24px 50px; padding:0;}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta p{margin-bottom:0}\n@media screen and (max-width: 735px) {\n\n  #pa-chatframe #sidepanel #contacts ul li.contact {\n    padding: 6px 0 46px 8px;\t\n  }\n}\n#pa-chatframe #sidepanel #contacts ul li.contact:hover {\n  background: #32465a;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact.active {\n  background: #32465a;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact.active span.contact-status {\n  border: 0px solid #32465a !important;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap {\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #contacts ul li.contact .wrap {\n    width: 100%;\n  }\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap span {\n  position: absolute;\n  left: 0;\n  margin: -2px 0 0 -2px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #95a5a6;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap span.online {\n  background: #2ecc71;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap span.away {\n  background: #f1c40f;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap span.busy {\n  background: #e74c3c;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap img {\n  width: 40px;\n  border-radius: 50%;\n  float: left;\n  margin-right: 10px;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #contacts ul li.contact .wrap img {\n    margin-right: 0px;\n  }\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta {\n  padding: 0px 0 0 0;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta {\n    display: none;\n  }\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta .name {\n  font-weight: 600;font-size: 13px; color:#000;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta .preview {\n\tcolor:#000;\n  margin: 0px 0 0 0;\n  padding: 0 0 0px;\n  font-weight: 400;\n  font-size: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact .wrap .meta .preview span {\n  position: initial;\n  border-radius: initial;\n  background: none;\n  border: none;\n  padding: 0 2px 0 0;\n  margin: 0 0 0 1px;\n  opacity: 0.5;\n}\n#pa-chatframe #sidepanel #contacts ul li.contact.active .meta .name,\n#pa-chatframe #sidepanel #contacts ul li.contact.active .meta .preview\n{color:#fff;}\n\n#pa-chatframe #sidepanel #bottom-bar {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n#pa-chatframe #sidepanel #bottom-bar button {\n  float: left;\n  border: none;\n  width: 50%;\n  padding: 10px 0;\n  background: #32465a;\n  color: #f5f5f5;\n  cursor: pointer;\n  font-size: 0.85em;\n  font-family: \"proxima-nova\", \"Source Sans Pro\", sans-serif;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #bottom-bar button {\n    float: none;\n    width: 100%;\n    padding: 15px 0;\n  }\n}\n#pa-chatframe #sidepanel #bottom-bar button:focus {\n  outline: none;\n}\n#pa-chatframe #sidepanel #bottom-bar button:nth-child(1) {\n  border-right: 1px solid #2c3e50;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #bottom-bar button:nth-child(1) {\n    border-right: none;\n    border-bottom: 1px solid #2c3e50;\n  }\n}\n#pa-chatframe #sidepanel #bottom-bar button:hover {\n  background: #435f7a;\n}\n#pa-chatframe #sidepanel #bottom-bar button i {\n  margin-right: 3px;\n  font-size: 1em;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #bottom-bar button i {\n    font-size: 1.3em;\n  }\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe #sidepanel #bottom-bar button span {\n    display: none;\n  }\n}\n#pa-chatframe .content {\n  float: right;\n  width: 60%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe .content {\n    width: calc(100% - 58px);\n    min-width: 300px !important;\n  }\n}\n@media screen and (min-width: 900px) {\n  #pa-chatframe .content {\n    width: calc(100% - 340px);\n  }\n  #pa-chatframe .content-100 {\n    width: 100%;\n  }\n}\n#pa-chatframe .content .contact-profile {\n  width: 100%;\n  height: 60px;\n  line-height: 60px;\n  background: #f5f5f5;\n}\n#pa-chatframe .content .contact-profile img {\n  width: 40px;\n  border-radius: 50%;\n  float: left;\n  margin: 9px 12px 0 9px;\n}\n#pa-chatframe .content .contact-profile p {\n  float: left;\n}\n#pa-chatframe .content .contact-profile .social-media {\n  float: right;\n}\n#pa-chatframe .content .contact-profile .social-media i {\n  margin-left: 14px;\n  cursor: pointer;\n}\n#pa-chatframe .content .contact-profile .social-media i:nth-last-child(1) {\n  margin-right: 20px;\n}\n#pa-chatframe .content .contact-profile .social-media i:hover {\n  color: #435f7a;\n}\n#pa-chatframe .content .messages {\n  height: auto;\n  min-height: calc(100% - 93px);\n  max-height: calc(100% - 93px);\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe .content .messages {\n    max-height: calc(100% - 105px);\n  }\n}\n#pa-chatframe .content .messages::-webkit-scrollbar {\n  width: 8px;\n  background: rgba(0, 0, 0, 0);\n}\n#pa-chatframe .content .messages::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.3);\n}\n#pa-chatframe .content .messages ul li {\n  display: inline-block;\n  clear: both;\n  float: left;\n  margin: 15px 15px 5px 15px;\n  width: calc(100% - 25px);\n  font-size: 0.9em;\n}\n#pa-chatframe .content .messages ul li:nth-last-child(1) {\n  margin-bottom: 20px;\n}\n#pa-chatframe .content .messages ul li.sent img {\n  margin: 6px 8px 0 0;\n}\n#pa-chatframe .content .messages ul li.sent p {\n  background: #435f7a;\n  color: #f5f5f5;\n}\n#pa-chatframe .content .messages ul li.replies img {\n  float: right;\n  margin: 6px 0 0 8px;\n}\n#pa-chatframe .content .messages ul li.replies p {\n  background: #f5f5f5;\n  float: right;\n}\n#pa-chatframe .content .messages ul li img {\n  width: 22px;\n  border-radius: 50%;\n  float: left;\n}\n#pa-chatframe .content .messages ul li p {\n  display: inline-block;\n  padding: 10px 15px;\n  border-radius: 8px;\n  max-width: 205px;\n  line-height: 130%;\n  font-size: 13px!important;\n}\n@media screen and (min-width: 735px) {\n  #pa-chatframe .content .messages ul li p {\n    max-width: 300px;\n  }\n}\n#pa-chatframe .content .message-input {\n  position: absolute;\n  bottom: 5px;\n  width: 100%;\n  z-index: 99;\n}\n#pa-chatframe .content .message-input .wrap {\n  position: relative;\n}\n#pa-chatframe .content .message-input .wrap input {\n  font-family: \"proxima-nova\", \"Source Sans Pro\", sans-serif;\n  float: left;\n  border: none;\n  width: calc(100% - 90px);\n  padding: 11px 32px 10px 20px;\n  font-size: 0.8em;\n  color: #32465a;\nborder-radius: 30px;\n    margin-left: 20px;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe .content .message-input .wrap input {\n    padding: 15px 32px 16px 8px;\n  }\n .webui-popover {\n    min-width: 100%;\n} \n}\n#pa-chatframe .content .message-input .wrap input:focus {\n  outline: none;\n}\n#pa-chatframe .content .message-input .wrap .attachment {\n  position: absolute;\n  right: 80px;\n  z-index: 4;\n  margin-top: 10px;\n  font-size: 1.1em;\n  color: #435f7a;\n  opacity: 0.5;\n  cursor: pointer;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe .content .message-input .wrap .attachment {\n    margin-top: 17px;\n    right: 65px;\n  }\n}\n#pa-chatframe .content .message-input .wrap .attachment:hover {\n  opacity: 1;\n}\n#pa-chatframe .content .message-input .wrap button {\n  float: right;\n  border: none;\n    width: 40px;\n    padding: 12px 0;\n    cursor: pointer;\n    background: #32465a;\n    color: #f5f5f5;\n    height: 40px;\n    border-radius: 50%;\n    margin-right: 20px;\n    margin-top: -2px;\n}\n@media screen and (max-width: 735px) {\n  #pa-chatframe .content .message-input .wrap button {\n    padding: 16px 0;\n  }\n}\n#pa-chatframe .content .message-input .wrap button:hover {\n  background: #435f7a;\n}\n#pa-chatframe .content .message-input .wrap button:focus {\n  outline: none;\n}\n\n\n\n/* ================================== Pagination ================================== */\n.pa-pagination ul{\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  background: #fff;\n  margin-top:30px;\n  padding: 8px;\n  border-radius: 50px;\n  box-shadow: 0px 10px 15px rgba(0,0,0,0.1);\n}\n.pa-pagination ul li{\n  color: #F37920;\n  list-style: none;\n  line-height: 45px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.3s ease;\n}\n.pa-pagination ul li.numb{\n  list-style: none;\n  height: 45px;\n  width: 45px;\n  margin: 0 3px;\n  line-height: 45px;\n  border-radius: 50%;\n}\n.pa-pagination ul li.numb.first{\n  margin: 0px 3px 0 -5px;\n}\n.pa-pagination ul li.numb.last{\n  margin: 0px -5px 0 3px;\n}\n.pa-pagination ul li.dots{\n  font-size: 22px;\n  cursor: default;\n}\n.pa-pagination ul li.btn{\n  padding: 0 20px;\n  border-radius: 50px;\n}\n.pa-pagination li.active,\n.pa-pagination ul li.numb:hover,\n.pa-pagination ul li:first-child:hover,\n.pa-pagination ul li:last-child:hover{\n  color: #fff;\n  background: #F37920;\n}\n/* ================================== Activities ================================== */\n\n.pa-filter-wrap {  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n     background-color: #f9f9f9;\n   border: 1px solid #ddd;\n   border-radius:10px; padding:20px;\n  }\n.pa-filter-name { margin-right:20px;}\n.choices__inner {\n   background-color:transparent !important;\n   border: 1px solid transparent!important;\n}\n.choices__list--dropdown {min-width: 200px;}\n.pa-act-profile { position:relative;  \ndisplay: flex;\n  justify-content: center;\n  align-items: center;}\n.pa-act-profile .pa-act-img{display:inline-block; width:50px; height:50px; border-radius:50px;}\n.pa-act-profile .pa-act-meta {display:inline-block; margin-left:20px;}\n.pa-act-profile .pa-act-meta h3 {font-size:14px; font-weight:bold;}\n.pa-act-action {font-size:12px; font-weight:normal; margin-top:15px !important; color:#b7b3b3; font-style:italic;}\n.pa-act-profile .pa-act-meta p {font-size:12px; font-weight:normal;}\n.pa-act-profile .pa-act-img img {width:100%;}\n.pa-upload-icon img { width:40px;}\n.pa-upload-wrap h4,\n.jl-heading {font-size:16px; font-weight:bold;}\n/* ================================== Timeline ================================== */\n\n.pa-timeline-wrap h4 { font-size:16px; font-weight:bold; margin:40px 0 20px 0;}\n.pa-timeline {\n  display: flex;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n.pa-timeline .image {\n  padding: 1em 2em;    margin-top: 20px;\n}\n.pa-timeline .image > div {\n  position: relative;\n  text-align: center;\n  font-size: 0.8em;\n  z-index:10;\n}\n.pa-timeline .image > div::after {\n  content: \"\";\n  width: 100%;\n  height: 0;\n  border-bottom: 1px solid #eee;\n  position: absolute;\n  top: 1.75em;\n  left: 2.5em;\n  z-index:1;\n}\n.pa-timeline .image .img {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  background:#eee;\n  text-align:center;\n      margin: 0 auto;\n}\n.pa-timeline .image .img img {\n    width: 65%;\n    margin: 0 auto;\n    display: block;\n    padding: 6px 0 0;\n}\n.pa-timeline .image span {\n  display: block;\n  clear: both;\npadding: 2px 7px;\n    margin: 0.5em 0;\n    background: #fff;\n    border-radius: 35px;\n}\n.pa-timeline .details {\n  position: relative;\n  flex-grow: 1;\n}\n.pa-timeline .details > div {\n  border: 1px solid #eee;\n  background: #eee;\n  border-radius: 0.5em;\n  padding: 1.5em;\n  margin: 1em 0;\n}\n.pa-timeline .details > div h1 {\n  color: #5ed3bf;\n  font-size: 1.4em;\n  margin: 0;\n  padding: 0 0 0.5em 0;\n  letter-spacing: 0.1em;\n}\n.pa-timeline .details > div p {\n  margin: 0;\n  padding: 0;\n  line-height: 150%;\n  font-size: 14px;\n}\n.pa-timeline .details::before {\n  content: \"\";\n  width: 0;\n  height: 100%;\n  border-left: 1px solid #eee;\n  position: absolute;\n  top: 0;\n  left:-4.3em;\n  z-index: 1;\n}\n/* ============ Toggle ============ */\n.btn-toggle {\n  margin: 0 4rem;\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 3rem;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n}\n.btn-toggle:focus,\n.btn-toggle.focus,\n.btn-toggle:focus.active,\n.btn-toggle.focus.active {\n  outline: none;\n}\n.btn-toggle:before,\n.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  transition: opacity 0.25s;\n}\n.btn-toggle:before {\n  content: 'Off';\n  left: -4rem;\n}\n.btn-toggle:after {\n  content: 'On';\n  right: -4rem;\n  opacity: 0.5;\n}\n.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  transition: left 0.25s;\n}\n.btn-toggle.active {\n  transition: background-color 0.25s;\n}\n.btn-toggle.active > .handle {\n  left: 1.6875rem;\n  transition: left 0.25s;\n}\n.btn-toggle.active:before {\n  opacity: 0.5;\n}\n.btn-toggle.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-sm:before,\n.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.4125rem;\n  width: 2.325rem;\n}\n.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-xs:before,\n.btn-toggle.btn-xs:after {\n  display: none;\n}\n.btn-toggle:before,\n.btn-toggle:after {\n  color: #6b7381;\n}\n.btn-toggle.active {\n  background-color: #29b5a8;\n}\n.btn-toggle.btn-lg {\n  margin: 0 5rem;\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 2.5rem;\n  width: 5rem;\n  border-radius: 2.5rem;\n}\n.btn-toggle.btn-lg:focus,\n.btn-toggle.btn-lg.focus,\n.btn-toggle.btn-lg:focus.active,\n.btn-toggle.btn-lg.focus.active {\n  outline: none;\n}\n.btn-toggle.btn-lg:before,\n.btn-toggle.btn-lg:after {\n  line-height: 2.5rem;\n  width: 5rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  transition: opacity 0.25s;\n}\n.btn-toggle.btn-lg:before {\n  content: 'Off';\n  left: -5rem;\n}\n.btn-toggle.btn-lg:after {\n  content: 'On';\n  right: -5rem;\n  opacity: 0.5;\n}\n.btn-toggle.btn-lg > .handle {\n  position: absolute;\n  top: 0.3125rem;\n  left: 0.3125rem;\n  width: 1.875rem;\n  height: 1.875rem;\n  border-radius: 1.875rem;\n  background: #fff;\n  transition: left 0.25s;\n}\n.btn-toggle.btn-lg.active {\n  transition: background-color 0.25s;\n}\n.btn-toggle.btn-lg.active > .handle {\n  left: 2.8125rem;\n  transition: left 0.25s;\n}\n.btn-toggle.btn-lg.active:before {\n  opacity: 0.5;\n}\n.btn-toggle.btn-lg.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-lg.btn-sm:before,\n.btn-toggle.btn-lg.btn-sm:after {\n  line-height: 0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.6875rem;\n  width: 3.875rem;\n}\n.btn-toggle.btn-lg.btn-sm:before {\n  text-align: right;\n}\n.btn-toggle.btn-lg.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.btn-toggle.btn-lg.btn-sm.active:before {\n  opacity: 0;\n}\n.btn-toggle.btn-lg.btn-sm.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-lg.btn-xs:before,\n.btn-toggle.btn-lg.btn-xs:after {\n  display: none;\n}\n.btn-toggle.btn-sm {\n  margin: 0 0.5rem;\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 3rem;\n  border-radius: 1.5rem;\n}\n.btn-toggle.btn-sm:focus,\n.btn-toggle.btn-sm.focus,\n.btn-toggle.btn-sm:focus.active,\n.btn-toggle.btn-sm.focus.active {\n  outline: none;\n}\n.btn-toggle.btn-sm:before,\n.btn-toggle.btn-sm:after {\n  line-height: 1.5rem;\n  width: 0.5rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.55rem;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  transition: opacity 0.25s;\n}\n.btn-toggle.btn-sm:before {\n  content: 'Off';\n  left: -0.5rem;\n}\n.btn-toggle.btn-sm:after {\n  content: 'On';\n  right: -0.5rem;\n  opacity: 0.5;\n}\n.btn-toggle.btn-sm > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  transition: left 0.25s;\n}\n.btn-toggle.btn-sm.active {\n  transition: background-color 0.25s;\n}\n.btn-toggle.btn-sm.active > .handle {\n  left: 1.6875rem;\n  transition: left 0.25s;\n}\n.btn-toggle.btn-sm.active:before {\n  opacity: 0.5;\n}\n.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-sm.btn-sm:before,\n.btn-toggle.btn-sm.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.4125rem;\n  width: 2.325rem;\n}\n.btn-toggle.btn-sm.btn-sm:before {\n  text-align: right;\n}\n.btn-toggle.btn-sm.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.btn-toggle.btn-sm.btn-sm.active:before {\n  opacity: 0;\n}\n.btn-toggle.btn-sm.btn-sm.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-sm.btn-xs:before,\n.btn-toggle.btn-sm.btn-xs:after {\n  display: none;\n}\n.btn-toggle.btn-xs {\n  margin: 0 0;\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1rem;\n  width: 2rem;\n  border-radius: 1rem;\n}\n.btn-toggle.btn-xs:focus,\n.btn-toggle.btn-xs.focus,\n.btn-toggle.btn-xs:focus.active,\n.btn-toggle.btn-xs.focus.active {\n  outline: none;\n}\n.btn-toggle.btn-xs:before,\n.btn-toggle.btn-xs:after {\n  line-height: 1rem;\n  width: 0;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  transition: opacity 0.25s;\n}\n.btn-toggle.btn-xs:before {\n  content: 'Off';\n  left: 0;\n}\n.btn-toggle.btn-xs:after {\n  content: 'On';\n  right: 0;\n  opacity: 0.5;\n}\n.btn-toggle.btn-xs > .handle {\n  position: absolute;\n  top: 0.125rem;\n  left: 0.125rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  border-radius: 0.75rem;\n  background: #fff;\n  transition: left 0.25s;\n}\n.btn-toggle.btn-xs.active {\n  transition: background-color 0.25s;\n}\n.btn-toggle.btn-xs.active > .handle {\n  left: 1.125rem;\n  transition: left 0.25s;\n}\n.btn-toggle.btn-xs.active:before {\n  opacity: 0.5;\n}\n.btn-toggle.btn-xs.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-xs.btn-sm:before,\n.btn-toggle.btn-xs.btn-sm:after {\n  line-height: -1rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.275rem;\n  width: 1.55rem;\n}\n.btn-toggle.btn-xs.btn-sm:before {\n  text-align: right;\n}\n.btn-toggle.btn-xs.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.btn-toggle.btn-xs.btn-sm.active:before {\n  opacity: 0;\n}\n.btn-toggle.btn-xs.btn-sm.active:after {\n  opacity: 1;\n}\n.btn-toggle.btn-xs.btn-xs:before,\n.btn-toggle.btn-xs.btn-xs:after {\n  display: none;\n}\n.btn-toggle.btn-secondary {\n  color: #6b7381;\n  background: #bdc1c8;\n}\n.btn-toggle.btn-secondary:before,\n.btn-toggle.btn-secondary:after {\n  color: #6b7381;\n}\n.btn-toggle.btn-secondary.active {\n  background-color: #ff8300;\n}\n\n.pa-items-center { text-align:center;}\n\nul.iq-edit-profile .nav-link.active {\n    color: #dfe0ff!important;\n    background: #0e4372 !important;\n}\nul.iq-edit-profile .nav-link {\n    border-radius: 8px 0 0 8px!important;\n}\n.iq-edit-profile .col-md-3:last-child .nav-link {\nborder-radius: 0 8px 8px 0!important;\n}\n.profile-img-edit { text-align:center;}\n.crm-profile-img-edit {height: 100px;\n    width: 100px;\n    line-height: 100px;\n    min-width: 100px;\n\tdisplay:block;\n\t    margin: 0 auto;\n    position: relative;\n\t}\nbody,\np,\n.btn,\n.iq-sidebar-menu .iq-menu li a {font-size:14px !important;}\n.datepicker table tr td, .datepicker table tr th {\n    text-align: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    border: none;\n    font-size: 12px;\n}\n\n.pa-pdf-icon { position:absolute; top: 50%;\n    right: 36px;\n    z-index: 9999; z-index:9998;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\t\n\t}\n.pa-pdf-icon img { width:60px;}\n.iq-navbar-custom .d-flex.align-items-center .change-mode,\n.iq-navbar-custom .nav-item.nav-icon.dropdown\n{display:none !important;}\n.iq-navbar-custom .nav-item.nav-icon.dropdown.caption-content {display:block !important;}\n\n.iq-navbar-custom {\n    margin-top: 20px;\n}\n.iq-sidebar {\n    position: fixed;\n    z-index: 99999 !important;\n}\n.tg  {border-collapse:collapse;border-spacing:0; margin-bottom:0 !important;}\n.tg td{font-size:12px;    text-align: left; font-weight:600;\n  overflow:hidden;padding:15px 6px;word-break:normal; position:relative;}\n.tg th{border-color:black;border-style:solid;border-width:1px;font-family:Arial, sans-serif;font-size:14px;\n  font-weight:normal;overflow:hidden;padding:10px 5px;word-break:normal;}\n.tg .tg-0lax{text-align:left;vertical-align:top}\n.tg .tg-0lax1 {\n    font-weight: 500;\n}\n.tg th.border, .tg td.border {\n    border: 1px solid #dee2e6;\n}\n\n.tg td td {\n    padding: 0px 0px;\n}\n.table-bordered.color-preface .color-preface.text-center td {\n    border: 1px solid #295883;\n}\n.color-preface.text-center td {text-align:center;}\n.tg .color-gray {background:#F5F5F6;}\n.tg .color-gray1{background:#F9F9F9;}\n.tg .color-gray2{background:#d2d9e3; color: #000; font-weight:600;}\n.tg .color-lred {background:#fefeff}\n.tg .color-green {background: #e2f1e8;color: #70a785;}\n.tg .color-preface {background: #F37920;color: #fff;}\n.tg .color-violet{background:#f7f4fd; color: #000;}\n.tg .color-gray3 {background: #fcfbfd;}\n.tg .color-white {background:#fff;}\n.tg .color-heading{background: #eff2f3;\n    color: #1e4466;\n\t}\n.tg .fix-height{ padding:0 15px;}\n.pl-0{padding-left:0 !important;}\n.pr-0 {padding-right:0 !important;}\n.tg .fix-height .td-0lax-h{padding:15px 15px;}\n.bold-font {font-weight:600;}\n.tg-row li {border-bottom:1px solid #f7f7f7;}\n.inline-block-icon { margin-left:10px;font-size:13px;}\n.pa-1w{width:30%;}\n.pa-num-w{width:10%;}\n.pa-num-w15{width:15%;}\n.pa-1w7 {\n    width: 7%;\n}\n.pa-1w1 {width: 1%;}\n.tg-row {margin:0; padding:0; list-style:none;}\n/* popover */\n\n.my-popover-btn {\n  --ui-popover-placement: top;\n}\n\n.d-none {\n  display: none\n}\n.pa-popover {display: inline;\n    position: relative; font-weight:600;}\n\t.pa-amount-wrap { background:#eee;}\n.pa-popover:hover {cursor:pointer;}\n.inline-block {display: inline;\n    position: relative;}\n.pa-preview-wrap i {font-size:20px;}\n.valid-feedback-wrap { margin-top:10px; font-size:12px;}\n.webui-popover .webui-popover-content {\n    padding: 9px 14px;\n    overflow: auto;\n    display: block;\n    width: 100%;\n}\n.webui-popover {\n    min-width: 350px;\n}\n.pa-close,\n.pa-edit-btn { display:inline-block; width:30px; height:30px; border-radius:50%;}\n.content-tabs {\n  border: 1px solid #efefef;\n  box-shadow: 5px 5px 20px rgba(255, 255, 255, 0.3);\n  margin-top: 30px;\n  width: 400px;\n  border-radius: 10px;\n  background: #fff;\n  overflow: hidden;\n}\n.content-tabs .tab-content {\n  padding: 0px 20px;\n  min-height: 300px;\n}\n.content-tabs .tab-content h3 i {\n  color: #f15009;\n}\n.content-tabs .tabs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0px;\n  margin: 0px;\n  height: 55px;\n  overflow: hidden;\n  background: #fff;\n}\n.content-tabs .tabs li {\n  display: inline-block;\n}\n.content-tabs .tabs li a {\n  background: transparent;\n  text-align: center;\n  transform: translate(0px, 17px);\n  display: block;\n  text-decoration: none;\n  padding: 0px 20px;\n  transition: all 0.5s ease-out;\n}\n.content-tabs .tabs li a .icon {\n  display: block;\n  margin-bottom: 15px;\n  color: #f15009;\n  font-size: 20px;\n}\n.content-tabs .tabs li a span {\n  display: block;\n  position: relative;\n  color: #f15009;\n  font-size: 15px;\n  font-weight: 600;\n}\n.content-tabs .tabs li a span:before {\n  content: \"\";\n  position: absolute;\n  background: #f15009;\n  bottom: -14px;\n  right: 0;\n  left: 0;\n  margin: 0px auto;\n  border-radius: 100px;\n  height: 3px;\n  width: 3px;\n  transition: all 0.5s ease-out;\n}\n.content-tabs .tabs li:hover a {\n  transform: translate(0px, -25px);\n}\n.content-tabs .tabs li.active a {\n  transform: translate(0px, -25px);\n}\n.content-tabs .tabs li.active a span:before {\n  height: 3px;\n  width: 30px;\n}\n\n/* ========================== Accordion ==========================*/\n#accordionGSTR .btn-link,\n#accordionGSTR .btn-link:hover,\n#accordionGSTR .btn-link:active {\n    font-weight: 600;\n    color: #000000!important;\n    text-decoration: none;\n    font-size: 20px !important;\n}\n#accordionGSTR .btn-link\n{\n    border-bottom: 1px solid #ddd;\n\t}\n#accordionGSTR .btn-link i {\n    position: absolute;\n    right: 20px;\n}\n.pa-gstr-acc .card-header {    padding: 4px 20px 20px 20px !important;}\n.gstr-tab a {font-size:13px; font-weight:600}\n.datepicker .form-control {\n\tpadding-left: 35px !important;\n    padding-top: 9px;\n}\n.pf-h-icon-box .iq-thumb {position: absolute;width: 50px; height: 50px; background: #ffffff00;left: 18px;top: 11px;}\n.pf-h-icon-box {text-align: left;text-align: left !important;padding-left: 40px;adding-top: 10px; margin-bottom:25px;}\n.pf-h-icon-box {min-height: 80px;}\t\n.pf-h-icon-box h6{ margin-top: 10px;}\n/* ========================== Accordion ==========================*/\n.pa-choose-date .datepicker {\n    z-index: 9990 !important;\n    text-align: left;\n}\n.datepicker-dropdown.dropdown-menu {\n    margin:10px 0 0 23px !important;\n}\n.tab-content {\n    text-align: left;\n\tpadding-left:0px;\n}\n.r-list-group .list-group-item {\n    padding: 0.75rem 0rem;font-size: 12px;\n}\n.r-list-group .list-group-item .las {margin:0 5px 0 0 !important;    \nfont-size: 20px;\ntop: 2px;\nposition: relative;\n}\n.r-list-group .list-group-item a {\n    color: #000000;\n    text-decoration: none;\n}\n.pa-text-danger {\n    color: #ff4545 !important;\n}\n.pa-text-success {color: #0ca940 !important;}\n.pa-text-info {color: #0263D1 !important;}\n.input-form {    position: relative;}\n.mx-calendar-panel-year .mx-icon-double-right::before,\n.mx-calendar-panel-year .mx-icon-double-left::before {\n  display: none;\n}\n.iq-top-navbar { z-index: 9999;}\n.iq-search-bar .pa-choose-date label {padding:6px 0 0 0 !important; text-align: right;font-size: 12px;}\n.iq-search-bar .pa-choose-date .row{margin-right: 0px; margin-left:0px;}\n.iq-search-bar .pa-choose-date .form-group {\n    margin-bottom: 0;\n}\n.iq-search-bar .pa-welcome-notifi {\n    margin-bottom: 0;\n    font-size: 20px !important;\n}\n.iq-search-bar .form-control {\n    height: 30px;\n    line-height: 18px;\n    border: 1px solid #f1f1f1;\n    font-size: 14px;\n    border-radius: 4px;\n}\n.iq-search-bar .input-group-addon {\n    position: absolute;\n    top: 7%;\n    left: 25px;\n    font-size: 18px;\n}\n.gstr-tab {\n    margin-top: -10px;\n}\n.pa-nav-tabs-1{border-bottom: 1px solid #f7f7f7;}\n.pa-nav-tabs-1 .nav-link.active, .pa-nav-tabs-1 .nav-item.show .nav-link,\n.pa-nav-tabs-1 .nav-item .nav-link:hover\n {\n    background-color: #F37920!important;\n\tborder-bottom: 1px solid #f7f7f7;\n\tcolor: #fff !important;\n}\n.pa-nav-tabs-1 .nav-link {margin-right:5px;\nborder-radius: 35px;\n    position: relative;\n\tborder-bottom: 1px solid #f7f7f7 !important;\n}\n.pa-nav-tabs-1 .nav-link.active{position:relative;}\n.pa-nav-tabs-1 .nav-link:hover:before,\n.pa-nav-tabs-1 .nav-link.active:before{position:absolute;\n    content: \"\";\n    margin:0 0.5em;\n    display:inline-block;\n    border: 7px solid transparent;\n    border-top: 8px solid #F37920;\n    border-bottom: 0 none;\n    bottom: -8px;\n    left: 37%;\n}\n.pa-nav-tabs-2 .nav-link {position:relative; margin-right:10px;}\n.pa-nav-tabs-2 .nav-link.active {background:#333;color:#fff; }\n.pa-nav-tabs-2 .nav-link:hover {background:#333;color:#fff !important;}\n.pa-nav-icon-tabs.pa-nav-tabs-2 .nav-link,\n.pa-nav-icon-tabs.pa-nav-tabs-2 .nav-link.active {padding-right:30px;}\n.pa-check-mark {position:absolute; \ndisplay:inline-block;\ntop: 8px;\n    right: 10px;\n    font-size: 14px;\n    color: #6bef97;\n\tdisplay:none\n}\n\n.nav-link.active .pa-check-mark{display:block;}\n.pa-show-note-count { border-radius:10px;}\n.pa-show-note-count .dropdown-menu {position:relative;background:transparent;    float: none; box-shadow:none; border:none;}\n.pa-show-note-count .dropdown-menu  li .item {\npadding: 5px 10px;\n    border-bottom: 1px solid #f1f1f1;\n    color: #535f6b;\n    font-size: 12px;\n    position: relative;\n    padding-left: 35px;\n    font-weight: 500;\n}\n.pa-show-note-count .dropdown-menu li {background:transparent;}\n.pa-show-note-count li .item i {\npadding:7px 8px;\n    line-height: 12px;\n    margin-right: 8px;\n    border-radius: 4px;\n    font-size: 12px;    \n\tposition: absolute;\n\t    left: 0;    \n\t\ttop: 8px;\n}\n.pa-show-note-count h2 {\n    font-size: 16px;\n    font-weight: 600;\n    border-top: 1px solid #efeded;\n    padding-top: 10px;\n    padding-left: 0px;\n}\n.pa-note-block { margin:20px 0 0 0;}\n.pa-show-note-count .item small{display:block;font-weight:400; } \n.nav-tabs .nav-link {\n    display: block;\n}\n.r-list-group-icon li {padding-left: 25px !important;}\n.r-list-group-icon li small {display:block;}\n.r-list-group-icon .list-group-item .las {\n    margin: 0 5px 0 0 !important;\n    font-size: 20px;\n    top: 2px;\n    position: absolute;\n    left: 0;\n    top: 15px;\n}\n.gstr-sidebar { background:#fafafa; border-radius:15px; padding:25px 15px 20px;}\n.gstr-sidebar .gstr-tab a {\n    font-size: 11px;\n    font-weight: 600;\n}\n.list-group-item {\n    padding: 0.75rem 0rem;\n    background-color:transparent;\n    border: 1px solid #eaebed;\n}\n.close-data {cursor:pointer;    \nbackground-color: #F37920 !important;\n    border-radius: 50%;\n    padding: 5px 7px;}\n.datepicker-btn {font-size:12px!important;padding: 5px 0.75rem;    border-radius: 5px;}\n\n.pfa-sidebar-acc { position:relative;}\n.pfa-sidebar-acc .pfa-header{ padding:12px 10px 8px 10px; \nborder-bottom:1px solid #f1f1f1;border-radius:0px;}\n.pfa-sidebar-acc .pfa-sidebar-acc-dec{ padding:0px;\n    background: #fff;\n    border-radius: 10px;\n    padding: 15px;\n    margin-top: -8px;transition: all .3s ease-in-out;\n}\n.gstr-sidebar h5{font-size: 16px !important; font-weight: 600; border-bottom:1px solid #f1f1f1; margin-bottom:20px;    padding-bottom: 10px;}\n.gstr-sidebar h6{font-size: 14px !important; font-weight: 600; padding-left:30px;}\n.gstr-sidebar small{ font-size: 11px !important; font-weight: 400;}\n.collapsible-link::before {\n  content: '';\n  width: 14px;\n  height: 2px;\n  background: #333;\n  position: absolute;\n  top: calc(50% - 1px);\n  right: -14px;\n  display: block;\n  transition: all 0.3s;\n}\n\n/* Vertical line */\n.collapsible-link::after {\n  content: '';\n  width: 2px;\n  height: 14px;\n  background: #333;\n  position: absolute;\n  top: calc(50% - 7px);\n  right: calc(-9px + 1px);\n  display: block;\n  transition: all 0.3s;\n}\n\n.collapsible-link[aria-expanded='true']::after {\n  transform: rotate(90deg) translateX(-1px);\n}\n\n.collapsible-link[aria-expanded='true']::before {\n  transform: rotate(180deg);\n}\n.pf-upload-count { position:absolute; left:-40px; width:30px; height:30px; line-height:30px; font-size:14px; font-weight:600;background:#F37920; color:#fff;\ntext-align:center; border-radius:50%;}\n.pf-upload-count.red-bg {background:#F37920;}\n.pf-upload-count.blue-bg {background:#F37920;}\n.badge-success1,.badge-success1:hover {background:#F37920 !important; color:#fff!important; }\n.pa-acc-card-body { background:transparent; padding:0 !important;}\n.pfa-down-all { text-align:right; font-size:14px; border-bottom:1px solid #fafafa; padding-bottom:10px; }\n.pfa-down-list  li {border-bottom:1px solid #eaebed;}\n.pfa-down-list a,.pfa-down-list a:hover { display:block; position:relative;color:#F37920!important;}\n.pfa-down-list a span{  position:absolute; right:0;}\n.pfa-down-list .pfa-down-list-icon{     width: 20px;\n    height: 20px;\n    font-size: 14px;\n    line-height: 20px;display:inline-block; border-radius:50%; text-align:center; background:#F37920; color:#fff;}\n.pa-acc-notes {\ncolor: #F37920!important;\n    border-color: #F37920!important;\n    background-color: #ffffff!important;\n}\n.pa-acc-card-body .pfa-down-all .badge {\n    padding: 0.3em 0.6em;\n    line-height: 1.3;\n    text-transform: capitalize;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    border-radius: 4px;\n}\n/* acc */\n\n/* Bento */\n.pa-bento-box{border-radius: 20px; padding:20px;    position: relative; overflow:hidden;}\n.mh-bentobox:after {\n  background: #fff;\n  content: \"\";\n  height: 140%;\n  left: -120%;\n  opacity: 0.2;\n  position: absolute;\n  top: -10%;\n  transform: rotate(35deg);\n  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);\n  width: 50px;\n  z-index: 99;\n}\n\n.mh-bentobox:hover:after {\n  left: 120%;\n  transition: all 550ms cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n.pa-bento-box-1{background:#c4b2e8;}\n.pa-bento-box-2{background:#f1dedd;}\n.pa-bento-box-3{background:#c4d48c;}\n.pa-bento-box-4{background:#ffdf6f;}\n.pa-bento-box-5{background:#f9a473;}\n.pa-bento-box-6{background:#96b0c3;}\n.pa-bento-box-7{background:#4a545e}\n.header-title h4 {font-size: 20px !important;}\n.pa-bento-box-7 h6 {color: #111;}\n.pa-bento-box-7 h4 {color: #fff;}\n.iq-thumb {width:60px; height:60px; background:#ffffff3b; border-radius:50% !important; text-align:center; line-height:60px;    margin: 0 auto;}\n.iq-thumb img {width:60%; margin:0 auto;}\n.header-title{padding-bottom: 10px; border-bottom: 1px solid #ffffff2e;}\n.mh-bentobox {min-height: 169px;}\n.pa-bento-box .profile-details .media.align-items-center {\n    border-bottom: 1px solid #ffffff2e;\n    padding-bottom: 10px;\n}\n.pa-forex-list {margin-top: 5px;\n    max-height: 181px;\n    overflow: hidden;\noverflow-y: scroll;\n    padding-right: 15px;\t\n\t}\n.pa-bento-box h6 a,\t\n.pa-bento-box h6 a:hover{color:#fff !important;}\n.pa-welcome-notifi span { display:inline-block; position:relative; width:40px; height:40px; line-height:40px; text-align:center; background:#ffffff36; border-radius:50%;}\t\n.pa-welcome-notifi span i {color:#fff;}\n.pa-p-d-small {     font-size: 12px !important;\n    color: #ffffff96 !important;}\n.pa-p-d-small.italic {font-style:italic;color: #fff !important;\n    font-size: 10px !important;}\n\t.profile-details { max-height:282px; \n\t    overflow: hidden;\noverflow-y: scroll;\n    padding-right: 15px;}\n.pa-welcome-notifi {\n    margin-bottom: 0px;\n\tfont-size: 18px !important;\n    color: #fff;\n}\t\n.mh-bentobox a {display:block;    position: absolute;\nleft: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n\t\n\t}\t\n.mh-bentobox a h6 {color:#fff !important}\t\n@media (min-width: 450px) {\n      .main-card {\n        width: 96%;\n        max-width: 400px;\n        height: calc(100% - 32px) !important;\n        border-radius: 8px !important;\n        max-height: 450px;\n      margin: 16px!important;\n      }\n    }\n\n .main-card.collapsed {\n      width: 48px !important;\n      height: 48px !important;\n      border-radius: 24px !important;\n      margin: 16px!important;\n\t      position: fixed;\n    }\n\n.main-card {\n      background: white;\n      color: white;\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n      border-radius: 0px;\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      right: 0;\n      bottom: 0;\n      position: fixed;\n      transition: all 0.5s;\n      box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2),0 6px 20px 0 rgba(0, 0, 0, 0.19);\n\t  z-index: 99999 !important;\n    }\n#chatbot_toggle {\n  position: absolute;\n  right: 0;\n  border: none;\n  height: 48px;\n  width: 48px;\n  background: #F37920;\n  padding: 14px;\n  color:white;\n}\n#chatbot_toggle:hover {\n  background: #111;\n}\n.line {\n  height: 1px;\n  background-color: #F37920;\n  width: 100%;\n  opacity: 0.2;\n}\n.main-title {\n  background-color: #F37920;\n  font-size: large;\n  font-weight: bold;\n  display: flex;\n  height: 48px;\n}\n.main-title>div{\n  height:48px;\n  width:48px;\n  display:flex;\n  margin-left:8px;\n}\n.main-title svg {\n  height: 24px;\n  margin: auto;\n}\n.main-title > span {\n  margin: auto auto auto 8px;\n}\n.chat-area {\n  flex-grow: 1;\n  overflow: auto;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n.input-message {\n  padding: 8px 48px 8px 16px;\n  flex-grow: 1;\n  border: none;\n}\n.input-message:focus {\n  outline: none;\n}\n.input-div {\n  height: 48px;\n  display: flex;\n}\n\n.input-send {\n  background: transparent;\n  width: 48px;\n  height: 48px;\n  right: 0%;\n  border: none;\n  cursor: pointer;\n}\n.input-send:hover {\n  background: lavender;\n}\n.input-send svg {\n  fill: #F37920;\n  margin: 11px 8px;\n}\n.chat-message-div {\n  display: flex;\n}\n\n.chat-message-sent {\n  background-color: white;\n  margin: 8px 16px 8px 6px;\n  padding: 8px 16px;\n  animation-name: fadeIn;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-in;\n  animation-duration: 100ms;\n  color: black;\n  border-radius: 8px 8px 2px 8px;\n  background-color: lavender;\n}\n\n.chat-message-received {\n  background-color: white;\n  margin: 8px 64px 8px 6px;\n  padding: 8px 16px;\n  animation-name: fadeIn;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-in;\n  animation-duration: 100ms;\n  color: black;\n  border-radius: 8px 8px 8px 2px;\n  background-color: lavender;\n}\n.chat-img-wrap img {width:30px;}\n.chat-img-wrap span {display:inline-block;}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* chat */\n.btn {    border-radius: 4px;}\n.content-page {margin-left: 215px;padding: 110px 0px 0px;}\n.iq-sidebar {width: 215px;}\n.iq-top-navbar {\n    width: calc(100% - 215px);\n}\n@media (max-width: 1299px)\n{\n.content-page {\n    margin-left: 0px;\n\n}\n.iq-top-navbar {\n    width: 100%;\n}\n.iq-footer {\n    margin-left: 0;\n    width: calc(100vw - 215px);\n}\n}\n\n.iq-footer {\n    margin-left: 0px;\n    width:100%;\n}\n.filepond--credits {display:none !important;}\n\n/* chat */\n@media (min-width: 450px) {\n      .main-card {\n        width: 96%;\n        max-width: 400px;\n        height: calc(100% - 32px) !important;\n        border-radius: 8px !important;\n        max-height: 450px;\n      margin: 16px!important;\n      }\n    }\n\n .main-card.collapsed {\n      width: 48px !important;\n      height: 48px !important;\n      border-radius: 24px !important;\n      margin: 16px!important;\n\t      position: fixed;\n    }\n\n    .main-card {\n      background: white;\n      color: white;\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n      border-radius: 0px;\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      right: 0;\n      bottom: 0;\n      position: absolute;\n      transition: all 0.5s;\n      box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2),0 6px 20px 0 rgba(0, 0, 0, 0.19);\n\t  z-index: 99999 !important;\n    }\n#chatbot_toggle {\n  position: absolute;\n  right: 0;\n  border: none;\n  height: 48px;\n  width: 48px;\n  background: #F37920;\n  padding: 14px;\n  color:white;\n}\n#chatbot_toggle:hover {\n  background: #111;\n}\n.line {\n  height: 1px;\n  background-color: #F37920;\n  width: 100%;\n  opacity: 0.2;\n}\n.main-title {\n  background-color: #F37920;\n  font-size: large;\n  font-weight: bold;\n  display: flex;\n  height: 48px;\n}\n.main-title>div{\n  height:48px;\n  width:48px;\n  display:flex;\n  margin-left:8px;\n}\n.main-title svg {\n  height: 24px;\n  margin: auto;\n}\n.main-title > span {\n  margin: auto auto auto 8px;\n}\n.chat-area {\n  flex-grow: 1;\n  overflow: auto;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n.input-message {\n  padding: 8px 48px 8px 16px;\n  flex-grow: 1;\n  border: none;\n}\n.input-message:focus {\n  outline: none;\n}\n.input-div {\n  height: 48px;\n  display: flex;\n}\n\n.input-send {\n  background: transparent;\n  width: 48px;\n  height: 48px;\n  right: 0%;\n  border: none;\n  cursor: pointer;\n}\n.input-send:hover {\n  background: lavender;\n}\n.input-send svg {\n  fill: #F37920;\n  margin: 11px 8px;\n}\n.chat-message-div {\n  display: flex;\n}\n\n.chat-message-sent {\n  background-color: white;\n  margin: 8px 16px 8px 64px;\n  padding: 8px 16px;\n  animation-name: fadeIn;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-in;\n  animation-duration: 100ms;\n  color: black;\n  border-radius: 8px 8px 2px 8px;\n  background-color: lavender;\n}\n\n.chat-message-received {\n  background-color: white;\n  margin: 8px 64px 8px 16px;\n  padding: 8px 16px;\n  animation-name: fadeIn;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-in;\n  animation-duration: 100ms;\n  color: black;\n  border-radius: 8px 8px 8px 2px;\n  background-color: lavender;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* chat */\n.btn {    border-radius: 4px;}\n.filepond--credits {display:none !important;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
